<style lang="stylus">
    .samePathTip
        font-size 14px
        color black
    .grid-item-active
        border 1px solid #017fff
        border-radius 8px
    .list-item-active
        background linear-gradient(90deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0) 100%);

    .files-new
        height 32px
        margin-bottom 18px
        display flex
        .files-new-btn
            position relative
            display flex
            justify-content center
            align-items center
            height 32px
            border-radius 6px
            border 1px solid #017fff
            cursor pointer
            user-select none
            padding 0 20px
            min-width 200px
            svg
                width 24px
                height 24px
                margin-right 5px
            >p
                max-width 120px
                white-space nowrap
                overflow hidden
                text-overflow ellipsis
            &.newbtn
                background #017fff
                color #fff
                margin-right 24px
                &:hover
                    background linear-gradient(0deg, rgba(0, 0, 0, 0.06), rgba(0, 0, 0, 0.06)), #017FFF;
            &.importbtn
                background #fff
                color #000
                border 1px solid rgba(0, 0, 0, 0.1);
                svg
                    fill #424242
                    stroke #424242
                &:hover
                    color #017fff
                    svg
                        fill #017fff
                        stroke #017fff
            .new-list
                width 100%
                border-radius 2px
                box-shadow 0 1px 6px rgba(0,0,0,0.2)
                outline none
                background-color white
                position absolute
                top 30px
                left 0
                z-index 999
                padding 4px 0
                color #000
                .new-list-item
                    padding 0 10px
                    display flex
                    height 36px
                    width 100%
                    align-items center
                    &:hover
                        background-color #e0e0e0
                    >span
                        text-indent 8px
                    .folderIco
                        width 20px
                        height 20px
                    .fileIco
                        width 22px
                        height 28px



    .list-header
        display flex
        margin-right 40px
        cursor pointer
        background #fff
        border-radius 6px
        height 40px
        margin-bottom 24px
        span
            pointer-events none
        >div
            &:hover
                background-color rgba(0, 0, 0, 2%)
        .icon-con
            margin-left: 6px
            height: 16px
            width: 8px
            pointer-events none
            .active-icon
                opacity 1
            svg
                opacity 0.3
                display block
                width: 8px;
                height: 8px;
        .file-name
            height: 100%;
            background: transparent;
            overflow: hidden;
            text-overflow: ellipsis;
            text-indent: 24px;
            box-sizing: border-box;
            border: none;
            outline: none;
            cursor: pointer;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            align-items: center;
            font-size 14px;
            width: 50%;
            user-select: none;
            &.files-name
                width 40%
        .file-time
            display: flex;
            align-items: center;
            white-space nowrap
            font-size 14px
            width: 30%;
            text-indent 15px
            &.files-time
                width 20%
        .file-customtag
            display: flex;
            align-items: center;
            white-space nowrap
            font-size 14px
            width: 20%;
            text-indent 15px
        .file-size
            display: flex;
            align-items: center;
            white-space nowrap
            font-size 14px
            width: 20%;
            text-indent 15px
    .files-scroll
        position relative
        width calc(100% + 56px)
        height calc(100% - 110px)
        margin-left -56px
        padding-left 56px
        overflow-x hidden
        overflow-y overlay
        .show-thumbnail
            position fixed
            font-size: 12px;
            border-radius: 6px;
            box-shadow: 0 1px 6px rgba(0,0,0,.2);
            z-index: 99;
            background: #fff;
            padding 6px 0
            width 204px
            >img
                width: 98%;
                height: 124px;
                object-fit: contain;
        .emptyCloud
            display flex
            flex-direction column
            align-items center
            justify-content center
            position absolute
            top 130px
            left 50%
            transform translate(-50%,0)
            span
                color #222
        &::-webkit-scrollbar
            width 8px
            pointer-events none
            background none
        &::-webkit-scrollbar-thumb
            background #D2D3D6
            border-radius 4px
        &::-webkit-scrollbar-track
            page_background()
        &::-webkit-scrollbar-track-piece
            background none
        &::-webkit-scrollbar-corner
            background none
        .files-folders
            overflow: auto;
            margin-top 0
            margin-bottom 12px
            .folder-item
                float: left;
                height: 40px;
                width: 200px;
                margin-right: 24px;
                margin-bottom: 24px;
                box-sizing: border-box;
                border-radius: 6px;
                cursor: pointer;
                user-select: none;
                position: relative;
                display: flex;
                -webkit-box-align: center;
                align-items: center;
                font-size: 12px;
                background: #fff;
                border: 1px solid transparent;
                svg
                    width: 24px;
                    height: 24px;
                    flex-shrink: 0;
                .folder-icon
                    margin 8px 8px 8px 12px
                .folder-menu
                    margin 8px 4px 8px 8px
                    border-radius: 6px;
                    &:hover
                        background: rgba(0, 0, 0, 0.04);
                .folder-text
                    display -webkit-box
                    -webkit-line-clamp 2
                    -webkit-box-orient vertical
                    vertical-align middle
                    background: transparent;
                    color: #000;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    box-sizing: border-box;
                    border: none;
                    outline: none;
                    cursor: pointer;
                    align-items: center;
                    width: 100%;
                    user-select: none;
                    pointer-events none
                .folder-rename
                    height: 100%;
                    background: transparent;
                    color: #000;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 0 5px;
                    box-sizing: border-box;
                    border: none;
                    outline: none;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    pointer-events none
                &:hover
                    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04), 0px 6px 15px rgba(0, 0, 0, 0.08);
                &.folder-item-active
                    border-color #017FFF !important
                    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04), 0px 6px 15px rgba(0, 0, 0, 0.08);
            .drop
                border-color #017FFF
                box-shadow 0px 2px 8px rgba(0, 0, 0, 0.04), 0px 6px 15px rgba(0, 0, 0, 0.08)


        .files-folders-list
            position relative
            overflow: auto;
            .folder-item
                padding-left 24px
                transition: all .2s ease-in-out;
                height: 52px;
                width: 100%;
                box-sizing: border-box;
                cursor: pointer;
                user-select: none;
                position: relative;
                display: flex;
                -webkit-box-align: center;
                align-items: center;
                font-size: 12px;
                border-radius 6px
                svg
                    margin: 0;
                    width: 24px;
                    height: 24px;
                    flex-shrink: 0;
                .folder-text
                    display inline
                    vertical-align middle
                    background: transparent;
                    color: #000;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding-left: 12px;
                    box-sizing: border-box;
                    border: none;
                    outline: none;
                    cursor: pointer;
                    align-items: center;
                    width: 100%;
                    user-select: none;
                span
                    height: 100%;
                    background: transparent;
                    color: #000;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding-left: 0 5px;
                    box-sizing: border-box;
                    border: none;
                    outline: none;
                    cursor: pointer;
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    user-select: none;
                    margin-left 8px;
                .folder-rename
                    height: 100%;
                    background: transparent;
                    color: #000;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 0 5px;
                    box-sizing: border-box;
                    border: none;
                    outline: none;
                    display: flex;
                    align-items: center;
                    width: 100%;
                &:hover
                    background: linear-gradient(90deg, rgba(0, 0, 0, 0.03) 0%, rgba(0, 0, 0, 0) 100%);
                &.folder-item-active
                    background: linear-gradient(90deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0) 100%);
        .files-box
            display flex
            flex-wrap wrap
            margin-right 40px
        .files-box-list
            overflow-x: visible;
    .drop
        background #dedede
    .files-box-selectArea
        position absolute
        top 0
        left 0
        width 100px
        height 100px
        border 1px solid #66ccff
        background-color rgba(111, 189, 255, 0.2)
        pointer-events none
    .files-box-multiDrag
        position absolute
        left 0
        top 0
        width 24px
        height 29px
        z-index 233
        pointer-events none
        .multiDrag-text
            position absolute
            right -10px
            top -10px
            width 20px
            height 20px
            background var(--themeColor);
            color #fff
            border-radius 50%
            text-align center
            line-height 20px
            font-size 12px
        .multiDrag-svg
            width 24px
            height 29px
    .files-container
        position relative
        page_background()
        width 100%
        height 100%
        flex 1
        padding 12px 0 0 40px
        user-select none
        &.ban
            pointer-events none

        .move-list-con
            padding 10px 15px 10px 0
            z-index 999
            border-radius 4px
            box-shadow 0 1px 6px rgba(0,0,0,.2)
            background-color #fff
            position fixed
            top 0
            left 0
            .move-toolbar
                height 26px
                margin-bottom 4px
            .move-enter-btn
                cursor pointer
                &:hover
                    background-color #005a9e
                >svg
                    width 15px
                    height 15px
                    margin 0 5px
                color: white
                background-color #017eff
                width 60px
                height 26px
                border-radius 2px
                margin-left 20px
                margin-bottom 4px
                display flex
                align-items center

            .move-list-item
                font-size 13px
                svg
                    width 13px
                    height 13px

        .tag-list
            padding 5px 0
            background-color #fff
            position fixed
            z-index 999
            border-radius 4px
            box-shadow 0 1px 6px rgba(0,0,0,.2)
            li
                height 32px
                line-height 32px
                min-width 120px
                text-align center
                &:hover
                    background #f5f7f6
                p
                    width 100%
                    white-space nowrap
                    text-overflow ellipsis
                    overflow hidden


        .rename-box
            position fixed
            top 0
            left 0
            width 100%
            bottom 0
            display flex
            align-items center
            justify-content center
            z-index 99
            .rename-content
                width 500px
                height 250px
                background #fff
                border-radius 6px
                box-shadow 0 6px 12px rgba(0,0,0,.3)
                .rename-title
                    position relative
                    padding 16px 22px
                    font-size 14px
                    border-bottom 1px solid #e0e0e0

                .rename-inp
                    margin 50px 22px
                    input
                        text-indent 12px
                        border-radius 4px
                        height 36px
                        width 100%
                        border 1px solid #007fff
                        outline none

                .rename-btn
                    margin 10px 22px
                    text-align right
                    .ivu-btn
                        margin 0 5px
                    .rename-confirm
                        padding 10px 30px
                        background #007fff
                        border-radius 4px
                        color #fff
                        margin-right 24px
                        cursor pointer

                    .rename-cancel
                        padding 10px 30px
                        background #d5d7db
                        border-radius 4px
                        color #000
                        cursor pointer
        .storage-box
            position fixed
            bottom 30px
            right 50px
            background #f9f9fb
            padding 20px
            text-align center
            border-radius 34px
            z-index 2
            box-shadow 0 2px 10px 0 rgba(0, 0, 0, 0.3)
            .storage-des
                font-size 12px
                color #b6b6b6
            &.isTeamsApp
                @media screen and (max-width: 500px)
                    display none
            .storage-bar
                position relative
                width 240px
                height 10px
                border 1px solid #b2b2b2
                border-radius 10px
                margin-top 10px
                overflow hidden

            .storage-use
                position absolute
                left 0
                top 0
                height 100%
                background var(--themeColor)
                max-width 100%
        @media screen and (max-width: 1440px)
            .files-right .files-search-box
                width 160px
            .files-right .files-search-box.is-fr
                width 180px
        .modal-no-mask
            .ivu-modal-mask
             background none


    .pc-storage-des
        position absolute
        left 56px
        top 65px
        font-size 12px
        color #b6b6b6
        z-index 9
    .workbench-box.isTeamsApp
        @media screen and (max-width: 500px)
            padding 30px 0 0 15px
</style>

<template>
    <div
        class="files-container"
        :class="{
            'workbench-box': !isPC,
            'dark-theme__workbench': isPCDarkMode == 2,
            ban: showLoading,
            isTeamsApp: isTeamsApp,
        }"
        :style="{ 'margin-top': pcSaveInput ? '60px' : '0' }"
        ref="rootDom"
        @click="clear"
        v-click-outside="closeFileMenu"
        @contextmenu="showTopContext"
    >
        <!-- 文件夹右键菜单 -->
        <!-- 获取DOM节点时，使用id代替虚拟dom的ref -->
        <RightMenu
            v-show="folderMenuBoxShow"
            :style="{ top: top + 'px', left: left + 'px' }"
            id="folderMenu"
            :menuList="folderMenuList"
            @handleClicks="handleClickFolder(...arguments)"
        />
        <!-- 文件右键菜单 -->
        <!-- 获取DOM节点时，使用id代替虚拟dom的ref -->
        <RightMenu
            v-show="contextmenuBoxShow"
            :style="{ top: top + 'px', left: left + 'px' }"
            id="fileMenu"
            :menuList="fileMenuList"
            @handleClicks="handleClickFile(...arguments)"
            @handleMouseenter="handleMouseenter(...arguments)"
            @handleMouseleave="handleMouseleave(...arguments)"
        />
        <!-- 空白处右键菜单 -->
        <!-- 获取DOM节点时，使用id代替虚拟dom的ref -->
        <RightMenu
            v-show="showTopMenu"
            :style="{ top: topMenuTop + 'px', left: topMenuLeft + 'px' }"
            id="topMenu"
            :menuList="topMenuList"
            @handleClicks="handleClickTopMenu(...arguments)"
        />
        <ul
            v-show="isShowTag"
            class="tag-list"
            ref="tagList"
            :style="{ top: tagListTop + 'px', left: moveLeft, right: moveRight }"
            @mouseleave="clearShowTag()"
        >
            <li v-for="(item, index) in tagList" tabindex="-1" @click="tagFunc(index)">
                <p :title="$t(item.label)">{{ $t(item.label) }}</p>
            </li>
        </ul>

        <WbHeader v-if="isPC" :outside="true" :from="'cloundFile'" @wbHeaderEvent="wbHeaderEvent" />

        <div class="filter-box" :class="{ 'filter-box-pc': isPC }">
            <div class="search-box" :class="{ 'is-fr': lang === 'fr' }">
                <input
                    autocomplete="off"
                    spellcheck="false"
                    type="text"
                    :data-locate="'search-input'"
                    v-model="searchValue"
                    :placeholder="$t('search')"
                    @keypress="enter($event)"
                />
                <button class="search-icon" :data-locate="'search-btn'" @click="search()">
                    <iconSymbol :name="'fileSearchIcon'" />
                </button>
            </div>
            <div class="order-box" v-if="!searchMode && layoutMode != 'list'">
                <div>
                    <Dropdown trigger="click" @on-click="setOrder">
                        <a href="javascript:void(0)">
                            {{ $t(orderName) }}
                        </a>
                        <DropdownMenu slot="list">
                            <DropdownItem name="name">{{ $t("name") }}</DropdownItem>
                            <DropdownItem name="time">{{ $t("time") }}</DropdownItem>
                            <DropdownItem name="size">{{ $t("size") }}</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>
                <iconSymbol :name="'orderIcon'" :style="{ transform: 'rotate(' + (rotate + 180) + 'deg)' }" @click.native="order()"></iconSymbol>
            </div>
            <button class="button-box" @click="setLayout()" :title="$t('switchView')">
                <iconSymbol :name="layoutMode == 'list' ? 'gridViewIcon' : 'listViewIcon'"></iconSymbol>
            </button>
        </div>

        <FileNum v-if="isPC" class="filenum-tips-pc" />

        <div style="overflow: hidden">
            <FilesSelector
                v-if="mulSelectMode"
                :type="'cloudFile'"
                :totalNum="activeList.length"
                :fileNum="selectFilesIndex.length"
                :s_margin="s_margin"
                :nowPrefix="nowPrefix"
                @selectAllFiles="selectAllFiles"
                @cancelSelect="cancelSelect"
                @downloadFiles="downloadFiles"
                @modalEvent="modalEvent"
                @delFiles="delFiles"
            />
        </div>
        <!-- 文件选择器 -->
        <FolderModal
            v-if="showFolderModal"
            :title="folderModalTitle"
            :isFolder="isFolder"
            :selectFolder="selectFolder"
            @confirm="moveEvent"
            @closeModal="closeModal"
        />
        <div class="files-new" v-show="!searchMode && !pcSaveInput && showFileNew">
            <div class="files-new-btn newbtn" @click="toShowNew2()">
                <iconSymbol class="addIcon" name="addIcon" />
                <p>{{ $t("addNew") }}</p>
                <div class="new-list" ref="newList2" tabindex="-1" @blur="showNewList2 = false" v-show="showNewList2">
                    <div class="new-list-item" @click.stop="toCreateFolder">
                        <iconSymbol class="folderIco" :name="'folderIcon'" />
                        <span style="text-indent: 10px">{{ $t("folder") }}</span>
                    </div>
                    <div class="new-list-item" @click.stop="toCreateFile">
                        <img class="fileIco" src="@/home/assets/img/files/file.svg" alt="" />
                        <span>{{ $t("eddxFile") }}</span>
                    </div>
                </div>
            </div>
            <div class="files-new-btn importbtn" @click="showImportModal()">
                <iconSymbol class="addIcon" name="importIcon" />
                <p>{{ $t("import") }}</p>
            </div>
        </div>
        <div v-if="layoutMode == 'list' && !searchMode" class="list-header">
            <div class="file-name files-name" @click="clickOrder('name')">
                <span>{{ $t("name") }}</span>
                <div class="icon-con">
                    <iconSymbol
                        :class="{ 'active-icon': orderName == 'name' && rotate == 180 }"
                        style="transform: rotate(180deg)"
                        :name="'fileUpIcon'"
                    ></iconSymbol>
                    <iconSymbol :class="{ 'active-icon': orderName == 'name' && rotate == 0 }" :name="'fileUpIcon'"></iconSymbol>
                </div>
            </div>
            <div class="file-time files-time" @click="clickOrder('time')">
                <span>{{ $t("time") }}</span>
                <div class="icon-con">
                    <iconSymbol
                        :class="{ 'active-icon': orderName == 'time' && rotate == 180 }"
                        style="transform: rotate(180deg)"
                        :name="'fileUpIcon'"
                    ></iconSymbol>
                    <iconSymbol :class="{ 'active-icon': orderName == 'time' && rotate == 0 }" :name="'fileUpIcon'"></iconSymbol>
                </div>
            </div>
            <div class="file-customtag">
                <span>{{ $t("customTag") }}</span>
            </div>
            <div class="file-size" @click="clickOrder('size')">
                <span>{{ $t("size") }}</span>
                <div class="icon-con">
                    <iconSymbol
                        :class="{ 'active-icon': orderName == 'size' && rotate == 180 }"
                        style="transform: rotate(180deg)"
                        :name="'fileUpIcon'"
                    ></iconSymbol>
                    <iconSymbol :class="{ 'active-icon': orderName == 'size' && rotate == 0 }" :name="'fileUpIcon'"></iconSymbol>
                </div>
            </div>
        </div>
        <div class="files-scroll" :style="{ height: scrollboxHeight }" @scroll="clear" ref="filesScroll" @mousedown="toDrag">
            <DragSelector
                :boxClassName="layoutMode == 'grid' ? 'files-item' : 'files-item-list'"
                :scrollDom="$refs.filesScroll"
                :containerDom="$refs.filesBoxList"
                :preventDragSelect="preventDragSelect"
                :isLazy="true"
                @dragMouseDown="dragMouseDown"
                @dragMouseMove="dragMouseMove"
                @dragMouseUp="dragMouseUp"
                @setActiveList="
                    (data) => {
                        this.selectFilesIndex = data;
                    }
                "
            />
            <div class="show-thumbnail" :style="{ top: thumbnail.top + 'px', left: thumbnail.left + 'px' }" v-if="thumbnail.state">
                <img :src="thumbnail.src" alt="" @error="coverError($event)" />
            </div>
            <div
                class="emptyCloud"
                v-cloak
                v-if="
                    userInfo &&
                    !loadFailed &&
                    !pcNoLogin &&
                    isGetFloder == false &&
                    folderList &&
                    filesList &&
                    folderList.length == 0 &&
                    filesList.length == 0
                "
            >
                <img src="@/home/assets/img/null-icon/default-null.svg" alt="" />
                <span>{{ $t("notTem") }}</span>
            </div>
            <div class="emptyCloud" v-cloak v-if="loadFailed && !pcNoLogin">
                <img src="@/home/assets/img/null-icon/network-error.svg" alt="" />
                <span>
                    <span style="margin-right: 4px">{{ $t("reloadPre") }}</span>
                    <a @click="reload()">{{ $t("reload") }}</a>
                </span>
            </div>
            <template v-if="!isOpenMyColud">
                <pcnewfile />
            </template>
            <template v-else>
                <pclogin />
            </template>
            <template v-if="layoutMode == 'grid'">
                <div class="files-folders" v-if="!searchMode && folderList.length > 0">
                    <div
                        class="folder-item"
                        :class="{
                            drop: dropIndex == index,
                            'folder-item-active': index == selectFolderIndex,
                            drop: dropFloderIndex == index,
                        }"
                        v-for="(item, index) in folderList"
                        :key="index"
                        @click.stop="openFolder(item)"
                        @mouseenter="folderEnter(index)"
                        @mouseleave="folderLeave()"
                        @contextmenu.prevent.stop="editFolder($event, item, index)"
                        @dragover.prevent
                    >
                        <!-- @drop="drop(item)"
                    @dragenter="dragenter(item, index)"
                    @dragleave="dragleave(item, index)" -->
                        <!-- <img :src="require('@/home/assets/img/files/folder.svg')"> -->
                        <iconSymbol class="folder-icon" :name="'folderIcon'" />
                        <div class="folder-text" :title="item.name">{{ item.name }}</div>
                        <!-- <input type="text" class="folder-rename" v-model="renameValue" v-if="folderRenameShow==index" @blur="renameFolder()"> -->
                        <iconSymbol :name="'folderMenuIcon'" class="folder-menu" @click.stop.native="editFolder($event, item, index)" />
                    </div>
                    <!-- <div class="folder-item" @click="createFolder()">
                        <iconSymbol :name="'addIcon'" style='width: 16px;height: 20px' />
                        <div class="folder-text">{{$t('createFolder')}}</div>
                    </div> -->
                </div>
                <div class="files-box" ref="filesBoxList">
                    <gridFile
                        v-for="(item, index) in searchMode ? searchList : filesList"
                        :key="index"
                        :mode="searchMode ? 'search' : 'files'"
                        :type="'files'"
                        :index="index"
                        :mulSelectMode="mulSelectMode"
                        :file="item"
                        @contextmenuEvent="
                            clearFolder();
                            clearShowTag();
                            closeTopMenu();
                        "
                        @closeContextmenu="closeFileMenu"
                        @enterMulSelectMode="mulSelectMode = true"
                        @cancelMulSelectMode="mulSelectMode = false"
                        @setFileItemTagStr="setFileItemTagStr"
                        @setStarFile="setStarFile"
                        @changeSaveInputName="setSaveInputName"
                    />
                </div>
            </template>
            <template v-if="layoutMode == 'list'">
                <div class="list-cons">
                    <div v-if="!searchMode" class="files-folders-list">
                        <div
                            class="folder-item"
                            v-for="(item, index) in folderList"
                            :class="{ 'folder-item-active': index == selectFolderIndex }"
                            @click.stop="selectFloder(item, index)"
                            :key="index"
                            @mouseenter="folderEnter(index)"
                            @mouseleave="folderLeave()"
                            @dblclick="openFolder(item)"
                            @contextmenu.prevent.stop="editFolder($event, item, index)"
                        >
                            <iconSymbol :name="'folderIcon'" />
                            <!-- <img :src="require('@/home/assets/img/files/folder-list.svg')" @error="listcoverError($event)"> -->
                            <div class="folder-text" style="">{{ item.name }}</div>
                            <!-- <input type="text" class="folder-rename" v-model="renameValue" v-if="folderRenameShow==index" @blur="renameFolder()"> -->
                        </div>
                    </div>

                    <div class="files-box-list" ref="filesBoxList">
                        <listFile
                            v-for="(item, index) in searchMode ? searchList : filesList"
                            :key="index"
                            :mode="searchMode ? 'search' : 'files'"
                            :type="'files'"
                            :index="index"
                            :mulSelectMode="mulSelectMode"
                            :file="item"
                            @contextmenuEvent="
                                clearFolder();
                                clearShowTag();
                                closeTopMenu();
                            "
                            @closeContextmenu="closeFileMenu"
                            @enterMulSelectMode="mulSelectMode = true"
                            @cancelMulSelectMode="mulSelectMode = false"
                            @clickTagStr="clickTagStr"
                            @setStarFile="setStarFile"
                            @changeSaveInputName="setSaveInputName"
                        />
                    </div>
                </div>
            </template>

            <template v-if="pcSaveInput">
                <saveInput :path="path" :selFileName="saveInputName" :fileList="filesList" />
            </template>

            <div class="files-box-multiDrag" v-show="dragFlag" :style="{ left: `${dragImgLeft}px`, top: `${dragImgTop}px` }">
                <p class="multiDrag-text">{{ selectFilesIndex.length }}</p>
                <!-- <iconSymbol class='multiDrag-svg' :name="'eddxFileIcon'" /> -->
            </div>
        </div>

        <div class="rename-box" v-if="renameShow" @click.stop>
            <div class="rename-content">
                <div class="rename-title">{{ $t("renameFile") }}</div>
                <div class="rename-inp">
                    <input
                        id="renameInput"
                        :placeholder="$t('inputFileTip')"
                        v-model="renameValue"
                        maxlength="32"
                        @keydown.esc="renameShow = false"
                        @keydown.enter="renameFile"
                    />
                </div>
                <div class="rename-btn" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                    <Button :loading="renaming" type="primary" @click="renameFile()">{{ $t("confirm") }}</Button>
                    <Button @click="renameShow = false">{{ $t("cancel") }}</Button>
                    <!-- <div class="rename-confirm" @click="renameFile()">{{$t('confirm')}}</div> -->
                    <!-- <div class="rename-cancel" @click="renameShow=false">{{$t('cancel')}}</div> -->
                </div>
            </div>
        </div>
        <div class="rename-box" v-if="folderRenameShow" @click.stop>
            <div class="rename-content">
                <div class="rename-title">{{ selectFolder.type == "created" ? $t("createFolder") : $t("renameFolder") }}</div>
                <div class="rename-inp">
                    <input
                        id="renameInput"
                        :placeholder="$t('inputFolderTip')"
                        v-model="renameValue"
                        maxlength="32"
                        @keydown.esc="folderRenameShow = false"
                        @keydown.enter="renameFolder"
                    />
                </div>
                <div class="rename-btn" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                    <Button :loading="renaming" type="primary" @click="renameFolder()">{{ $t("confirm") }}</Button>
                    <Button @click="folderRenameShow = false">{{ $t("cancel") }}</Button>
                    <!-- <div class="rename-confirm" @click="renameFolder()">{{$t('confirm')}}</div> -->
                    <!-- <div class="rename-cancel" @click="folderRenameShow=false">{{$t('cancel')}}</div> -->
                </div>
            </div>
        </div>
        <Modal v-model="shareTipState" :title="$t('tip')" :ok-text="$t('confirm')" :cancel-text="$t('cancel')" @on-ok="toShare" class="modal-no-mask">
            <p>{{ $t("shareTip") }}</p>
        </Modal>
        <Modal v-model="samePathModal" width="420" :title="$t('samePathTitle')">
            <p class="samePathTip" v-if="operateSameIndexs.length === 1">
                {{ $t("oneSamePreTip") + '"' + operateNames[operateSameIndexs[0]] + '"' + $t("oneSameAffTip") }}
            </p>
            <p class="samePathTip" v-else>{{ $t("mulSamePreTip") + operateSameIndexs.length + $t("mulSameAffTip") }}</p>
            <div slot="footer" style="display: flex">
                <Button :loading="pasteLoading === 1" @click="prePaste(1)">{{ $t("replaceFile") }}</Button>
                <Button :loading="pasteLoading === 2" @click="prePaste(2)">{{ $t("skipFile") }}</Button>
                <Button
                    style="margin-left: auto !important"
                    v-if="operateType !== 'cut'"
                    type="primary"
                    :loading="pasteLoading === 3"
                    @click="prePaste(3)"
                >
                    {{ $t("keepAllFile") }}
                </Button>
            </div>
        </Modal>

        <Modal
            v-model="showFileItemTagStrModal"
            :title="$t('tip')"
            :ok-text="$t('confirm')"
            :cancel-text="$t('cancel')"
            @on-ok="changeFileItemTagStr"
            @on-cancel="resetFileItemTag"
        >
            <div style="display: flex; align-items: center">
                <p style="margin-right: 10px; white-space: nowrap">{{ $t("customTips") }}</p>
                <Input v-model="fileItemTagStr" :maxlength="30" size="small" style="width: 380px" />
            </div>
        </Modal>

        <div class="storage-box" v-if="isTeamsApp && userInfo && userInfo.used_storage" :class="{ isTeamsApp: isTeamsApp }">
            <div class="storage-des">
                {{ $t("usedStorage") }}{{ ((userInfo.used_storage || 0) / 1024 / 1024).toFixed(2) }} M /
                {{ (userInfo.max_storage / 1024 / 1024).toFixed(2) }} M
            </div>
            <div class="storage-bar">
                <div class="storage-use" :style="{ width: (userInfo.used_storage / userInfo.max_storage) * 100 + '%' }"></div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Mixins, Watch } from "vue-property-decorator";
    import fileItem from "./fileItem";
    import Topbar from "./Topbar.vue";
    import Slider from "./Slider.vue";
    import gridFile from "./gridFile.vue";
    import listFile from "./listFile.vue";
    import saveInput from "./saveInput.vue";
    import naturalsort from "javascript-natural-sort";
    import FilesSelector from "./FilesSelector.vue";
    import FolderModal from "./FolderModal.vue";
    import RightMenu from "./RightMenu.vue";
    import pclogin from "@/home/parts/pclogin.vue";
    import pcnewfile from "@/home/parts/pcnewfile.vue";
    import DragSelector from "./DragSelector.vue";
    import WbHeader from "./Wb-header.vue";
    import FileNum from "./vip/fileNum.vue";
    import { checkFileName } from "@/public/utils/tool";
    naturalsort.insensitive = true;
    declare var JSZip: any;
    declare var saveAs: any;
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            Topbar,
            Slider,
            gridFile,
            listFile,
            saveInput,
            FilesSelector,
            FolderModal,
            RightMenu,
            pclogin,
            pcnewfile,
            DragSelector,
            WbHeader,
            FileNum,
        },
    })
    export default class Files extends Mixins(fileItem) {
        mouseEventType = -1; // 0 dragSelect   1 dragFiles
        folderList = [];
        filesList = [];
        showNewList: boolean = false;
        showNewList2: boolean = false;
        isShowTag: boolean = false;
        isFolder: boolean = false; // 显示移动或复制弹窗时，操作对象是文件夹
        scrollStep = 0;

        renaming = false;

        loadFailed = false;

        mulSelectMode = false;
        fileItemTagStr = "";
        nowPrefix = "";
        nowPrefixId = 0;
        tagListTop: number = 0;
        tagListAttr: any = {};

        tagList = [
            {
                id: 1,
                value: "edraw_1",
                label: "waitdone",
            },
            {
                id: 2,
                value: "edraw_2",
                label: "done",
            },
            {
                id: 3,
                value: "edraw_3",
                label: "waitchange",
            },
            {
                id: 4,
                value: "",
                label: "custom",
            },
            {
                id: 0,
                value: "edraw_0",
                label: "none",
            },
        ];

        showFolderModal = false;

        get folderModalTitle() {
            if (this.operateType == "move") {
                return this.$t("moveTo");
            } else if (this.operateType == "copy") {
                return this.$t("copyTo");
            } else {
                return this.$t("folder");
            }
        }

        get topMenuList() {
            return [
                { label: this.$t("refresh"), underline: true },
                { label: this.$t("createFolder") },
                { label: this.$t("createFile"), underline: true },
                { label: this.$t("importFile") },
            ];
        }
        handleClickTopMenu(...args) {
            let index = args[0];
            let clickEvents = new Map([
                [0, "refresh"],
                [1, "newFolder"],
                [2, "newFile"],
                [3, "import"],
            ]);
            const key = clickEvents.get(index);
            key && this.topMenuClick(key);
        }
        get folderMenuList() {
            let list = [
                { key: "rename" },
                { key: "del" },
                // { key: "copy" },
                // { key: "cut" },
                { key: "download" },
                { key: "moveTo" },
                { key: "copyTo" },
            ];
            let resultList = [];
            list.map((item) => {
                resultList.push(Object.assign({}, item, { label: this.$t(item.key) }));
            });
            return resultList;
        }
        handleClickFolder(...args) {
            let key = args[0],
                event = args[1];
            let clickEvents = new Map([
                [
                    "rename",
                    () => {
                        this.folderRename();
                    },
                ],
                [
                    "del",
                    () => {
                        this.delFolder();
                    },
                ],
                // [ "copy", () => { this.toCopy() } ],
                // [ "cut", () => { this.toCut() } ],
                [
                    "download",
                    () => {
                        this.downloadFolder();
                    },
                ],
                [
                    "moveTo",
                    () => {
                        event.stopPropagation();
                        this.toShowMoveList("move", 1);
                    },
                ],
                [
                    "copyTo",
                    () => {
                        event.stopPropagation();
                        this.toShowMoveList("copy", 1);
                    },
                ],
            ]);
            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
        }
        get fileMenuList() {
            let starLabel = "";
            const hasStar = this.selFiles[0] && this.selFiles[0].info.start_tag == 1;
            if (this.lang == "kr") {
                starLabel = hasStar ? "즐겨찾기 취소" : "즐겨찾기";
            } else if (this.lang == "jp") {
                starLabel = hasStar ? "スターをキャンセル" : "スターを追加";
            } else {
                // 使用 $tc() 代替 $t() 以解决使用 + 运算符时候出现的类型报错（$tc返回字符串，$t返回 TranslateResult 类型）
                starLabel = hasStar ? this.$tc("cancel") + this.$tc("star") : this.$tc("set") + this.$tc("star");
            }

            let list = [
                { key: "open", ban: this.selectFilesIndex.length != 1 },
                { key: "rename", ban: this.selectFilesIndex.length != 1 },
                {
                    key: "addCustomTemplate",
                    hide: !this.isPC,
                    ban: this.selectFilesIndex.length != 1,
                    underline: true,
                },
                { key: "share", ban: this.selectFilesIndex.length != 1, hide: !this.isTeamsApp },
                { key: "download", underline: true },
                // { key: "createCopy" },
                // { key: "copy" },
                // { key: "cut" },
                { key: "moveTo" },
                { key: "copyTo" },
                { key: "star", ban: this.selectFilesIndex.length != 1 },
                {
                    key: "tag",
                    suffixIcon: "filesitem-varrow",
                    ban: this.selectFilesIndex.length != 1,
                    underline: true,
                },
                { key: "del" },
            ];
            let resultList = [];
            list.filter((i) => (i.hasOwnProperty("hide") ? i.hide : true)).map((item) => {
                resultList.push(
                    Object.assign({}, item, {
                        label: item.key == "star" ? starLabel : this.$t(item.key),
                    })
                );
            });
            return resultList;
        }
        handleClickFile(...args) {
            let key = args[0],
                event = args[1];
            let clickEvents = new Map([
                [
                    "open",
                    () => {
                        this.selectFilesIndex.length == 1 && this.menuOpenFiles(this.selFiles[0]);
                    },
                ],
                [
                    "rename",
                    () => {
                        this.selectFilesIndex.length == 1 && this.rename();
                    },
                ],
                [
                    "addCustomTemplate",
                    () => {
                        this.selectFilesIndex.length == 1 && this.add2Template();
                    },
                ],
                [
                    "share",
                    () => {
                        this.selectFilesIndex.length == 1 && this.menuShare();
                    },
                ],
                [
                    "download",
                    () => {
                        if (
                            !this.$checkAuth({
                                type: "downloadFiles",
                                buyTrigger: "others",
                                pcParams: { newUpgrade: 0, upgrade: 0 },
                            })
                        )
                            return;
                        this.downloadFiles();
                    },
                ],
                // [ "createCopy", () => { this.toCreateCopy() } ],
                // [ "copy", () => { this.toCopy() } ],
                // [ "cut", () => { this.toCut() } ],
                [
                    "moveTo",
                    () => {
                        event.stopPropagation();
                        this.toShowMoveList("move");
                    },
                ],
                [
                    "copyTo",
                    () => {
                        event.stopPropagation();
                        this.toShowMoveList("copy");
                    },
                ],
                [
                    "star",
                    () => {
                        event.stopPropagation();
                        this.selectFilesIndex.length == 1 && this.setStarFile();
                    },
                ],
                [
                    "tag",
                    () => {
                        event.stopPropagation();
                    },
                ],
                [
                    "del",
                    () => {
                        this.delFiles();
                    },
                ],
            ]);
            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
        }
        handleMouseenter(...args) {
            let key = args[0],
                event = args[1];
            if (key == "tag") this.selectFilesIndex.length == 1 && this.toShowTag(event);
        }
        handleMouseleave(...args) {
            let key = args[0],
                event = args[1];
            if (key === "tag") this.clearShowTag(event);
        }
        get showFileItemTagStrModal() {
            return this.$store.state.showFileItemTagStrModal;
        }
        set showFileItemTagStrModal(v) {
            this.$store.commit("setState", {
                type: "showFileItemTagStrModal",
                data: v,
            });
        }
        get showLoading() {
            return this.$store.state.showLoading;
        }

        get pcNoLogin() {
            return this.isPC && !this.params.islogin;
        }
        get showFileNumTips() {
            return this.$store.getters.showFileNumTips(this);
        }
        get scrollboxHeight() {
            let selectorH = 46; // 多选工具栏高度
            let newH = this.pcSaveInput ? 0 : 50; // 新建按钮高度 含margin-b
            let pathTitle = this.isPC ? 43 : 0; // 文件路径标题
            let fileNumLimit = this.isPC && this.showFileNumTips ? 48 : 0;
            let listHeadH = 64; // 列表头高度 含margin-b
            let selectorMarginT = 0; // 多选工具栏margin-top
            let selectorMarginB = 16; // 多选工具栏margin-bottom
            let baseHeight = this.mulSelectMode ? selectorH + selectorMarginT + selectorMarginB : 0;
            let allHeight = baseHeight + pathTitle + fileNumLimit;
            if (this.layoutMode == "list") {
                return this.searchMode ? `calc(100% - ${allHeight}px)` : `calc(100% - ${allHeight + newH + listHeadH}px)`;
            } else {
                return this.searchMode ? `calc(100% - ${allHeight}px)` : `calc(100% - ${allHeight + newH}px)`;
            }
        }
        get s_margin() {
            return "0 40px 16px 0";
        }
        toPCLogin() {
            (<any>window).$qt.jsCallUpdateLoginTrigger && (<any>window).$qt.jsCallUpdateLoginTrigger("toUseCloudFile");
            (<any>window).$qt.jsCallUserLogin();
        }

        @Watch("userInfo.islogin")
        onLoginChanged(val, oldval) {
            if (this.isPC) {
                if (val && !oldval) {
                    this.reload();
                    this.$bus.$emit("pcLoginEvenvt");
                } else if (!val && oldval) {
                    this.folderList = [];
                    this.filesList = [];
                    this.searchList = [];
                    this.isGetFloder = false;
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                }
            }
        }
        get activeList() {
            return this.searchMode ? this.searchList : this.filesList;
        }
        set activeList(v) {
            (this.searchMode && (this.searchList = v)) || (this.filesList = v);
        }
        get top() {
            return this.$store.state.layoutTop;
        }
        set top(v) {
            this.$store.commit("setState", {
                type: "layoutTop",
                data: v,
            });
        }
        get left() {
            return this.$store.state.layoutLeft;
        }
        set left(v) {
            this.$store.commit("setState", {
                type: "layoutLeft",
                data: v,
            });
        }
        menuWidth = 0;
        get moveLeft() {
            if (document.documentElement.clientWidth - this.left - this.menuWidth < 100) {
                return "unset";
            } else {
                return this.left + this.menuWidth + "px";
            }
        }
        get moveRight() {
            if (this.moveLeft == "unset") {
                return document.documentElement.clientWidth - this.left + "px";
            }
            return "unset";
        }
        @Watch("folderMenuBoxShow")
        onfolderChange(val: boolean) {
            if (val) {
                this.$nextTick(() => {
                    this.menuWidth = document.getElementById("folderMenu").clientWidth;
                });
            }
        }
        @Watch("contextmenuBoxShow")
        onfileChange(val: boolean) {
            if (val) {
                this.$nextTick(() => {
                    this.menuWidth = document.getElementById("fileMenu").clientWidth;
                });
            }
        }

        get folderMenuBoxShow() {
            return this.$store.state.folderContextShow;
        }
        set folderMenuBoxShow(v) {
            this.$store.commit("setState", {
                type: "folderContextShow",
                data: v,
            });
        }
        get contextmenuBoxShow() {
            return this.$store.state.fileContextShow;
        }
        set contextmenuBoxShow(v) {
            this.$store.commit("setState", {
                type: "fileContextShow",
                data: v,
            });
        }
        get selFiles() {
            let list = this.searchMode ? this.searchList : this.filesList;
            return list.filter((_, i) => {
                return this.selectFilesIndex.includes(i);
            });
        }
        // selectFilesIndex = []
        get selectFilesIndex() {
            return this.$store.state.selectFilesIndex;
        }
        set selectFilesIndex(v) {
            this.$store.commit("setState", {
                type: "selectFilesIndex",
                data: v,
            });
        }
        renameShow = null;
        renameValue = "";
        folderRenameShow = null;
        selectFolder = null;
        selectFolderIndex = null;
        host = "";
        rotate = localStorage.getItem("max_order") || 0;
        orderName = localStorage.getItem("max_sort") || "time";
        searchList = [];
        searchValue = "";
        @Watch("renameShow")
        autoFocus(val) {
            if (val) {
                this.$nextTick(() => {
                    let dom = <HTMLInputElement>document.getElementById("renameInput");
                    dom && dom.focus();
                });
            }
        }
        get layoutMode() {
            return this.$store.state.layoutMode;
        }
        set layoutMode(v) {
            this.$store.commit("setState", {
                type: "layoutMode",
                data: v,
            });
        }
        get path() {
            return this.$store.state.cloudFile.path;
        }
        set path(v) {
            this.$store.commit("setCloudFileStatus", {
                path: v,
            });
        }
        get searchMode() {
            return this.$store.state.cloudFile.searchMode;
        }
        set searchMode(v) {
            this.$store.commit("setCloudFileStatus", {
                searchMode: v,
            });
        }
        wbHeaderEvent(obj) {
            let instance = this;
            let func = instance && obj.func_name ? instance[obj.func_name] : null;
            func && func(obj.args);
        }
        get shareTipState() {
            return this.$store.state.shareTipState;
        }
        set shareTipState(v) {
            this.$store.commit("setState", {
                type: "shareTipState",
                data: v,
            });
        }
        @Watch("shareTipState")
        closeMenue(val) {
            val && this.closeFileMenu();
        }

        dragItem = { key: "", name };
        dragIndex = 0;
        dropIndex = null;

        ctrldown = false;

        dragFlag = false; // 进入拖拽item模式
        dragImgLeft = 0;
        dragImgTop = 0;
        dragItemList = [];
        dropFloderIndex = -1;

        showPathBox = false;

        samePathModal = false;
        operateIds = [];
        operateType = "";
        operateNames = [];
        operateSameIndexs = [];
        isOperating = false;

        isGetFloder = null;
        pasteLoading = 0;

        prePaste(type: number) {
            this.pasteLoading = type;
            if (type === 1) {
                this.toPaste(false);
            } else if (type === 2) {
                this.toPaste(true, true);
            } else {
                this.toPaste(true);
            }
        }

        toShowNew() {
            this.showNewList = true;
            this.$nextTick(() => {
                (<any>this.$refs.newList).focus();
            });
        }
        toShowNew2() {
            if (!this.$validateLogin()) return;
            this.showNewList2 = true;
            this.$nextTick(() => {
                (<any>this.$refs.newList2).focus();
            });
        }
        showImportModal() {
            let win: any = window;
            if (!this.$validateLogin()) return;
            if (this.isPC && win.$qt) {
                if (win.$qt.jsCallSetDragFlag) {
                    win.$qt.jsCallSetDragFlag(true);
                } else {
                    // 低版本兼容
                    this.$edMessage.error(this.$t("useSymbolTip"));
                    return;
                }
            }
            this.$store.commit("setState", {
                type: "showImportModal",
                data: true,
            });
        }
        clear(e) {
            this.closeFileMenu();
            this.clearShowTag();
            // if(e.target.className && e.target.className.indexOf){
            //     if(e.target.className.indexOf("files-scroll") !== -1 || e.target.className.indexOf("list-cons") !== -1 || e.target.className.indexOf("files-container") !== -1){
            //         this.clearFile();
            //         this.clearFolder();
            //     }
            // }
        }

        pathBox() {
            this.showPathBox = true;
            document.addEventListener("click", this.closePathBox);
        }
        closePathBox(e) {
            let dom = this.$refs.pathBox as HTMLElement;
            if (!dom || !e.target) return;
            if (dom != e.target && !dom.contains(e.target)) {
                this.showPathBox = false;
                document.removeEventListener("click", this.closePathBox);
            }
        }
        toShowMoveList(flag, type = 0) {
            // 默认为操作文件，参数为1时操作文件夹
            this.showFolderModal = true;
            this.closeFileMenu();
            this.isFolder = !!type;
            !!flag && (this.operateType = flag);
        }

        toCreateFolder() {
            this.$track("files", "create folder");
            this.showNewList = false;
            this.createFolder();
        }
        toCreateFile() {
            this.$gaTrack("openFileProcess_newEmptyFile", "newFileWay: cloudNewBtn");
            this.$gaTrack("openFileProcess_newEmptyFileDiagramType", "diagramType: default");
            this.$track("files", "create file");
            this.sensors.track("cloudNewBtn", {
                Catalogues: "openFileProcess",
                new_file_way: "newBtn",
                diagram_type: "notUseTemplate",
            });
            this.sensors.track("newEmptyFile", {
                Catalogues: "openFileProcess",
                new_file_way: "newBtn",
                diagram_type: "emptyFile",
            });
            this.showNewList = false;
            this.addNewPage();
        }
        setLibs() {
            let libs = localStorage.getItem("libs");
            if (!libs || (libs && !libs.length)) {
                localStorage.setItem("libs", "[373, 14, 4]");
            }
        }
        addNewPage() {
            let ts: any = this;
            if (!this.isPC) {
                let maxAction = this.$store.state.appState;
                if (maxAction) {
                    if (maxAction == "create") (<any>this).$edMessage.success(this.$t("create"));
                    return;
                }
            }
            this.setLibs();

            // if (!this.$validateLogin()) return;

            let newTab: any;
            if (!this.isPC) {
                if (!this.openInTabs) {
                    newTab = window.open(`${window.location.origin}${(<any>this.$router).options.base}app.html`, "");
                }
            }

            // newTab.location.href = `${window.location.origin}/app.html?action=openfile`;
            // return;
            if (false && this.isPC) {
                let path = this.path.length ? this.path.join("/") + "/" : "";
                let libs = localStorage.getItem("libs");
                let paramForPc = {
                    name,
                    newPath: path,
                    libs,
                    type: "new",
                };
                (<any>window).$qt.jsCallCloudFileOperate(JSON.stringify(paramForPc));
            } else {
                let limitCallback = (type = "") => {
                    newTab && newTab.close();
                    if (type == "showLimitModal") {
                        this.$bus.$on("limitModalContinue", () => {
                            console.log("on event");
                            this.$bus.$off("limitModalContinue");
                            this.addNewPage();
                        });
                        this.$store.commit("setState", {
                            type: "showLimitFileModal",
                            data: true,
                        });
                    } else if (type == "showLimitCloudSpaceVIP") {
                        if (this.fuser) {
                            this.$bus.$emit("showCloudSpaceVipTips");
                        } else {
                            this.$checkAuth({
                                type: "cloudSpaceVIP",
                                buyTrigger: "cloudSpacePop",
                                pcParams: { newUpgrade: 6, upgrade: 0 },
                            });
                        }
                    } else if (type == "showLimitCloudSpace") {
                        this.$checkAuth({
                            type: "cloudSpace",
                            buyTrigger: "cloudSpacePop",
                            pcParams: { newUpgrade: 6, upgrade: 0 },
                        });
                    } else {
                        this.$store.commit("toPublicStatus", {
                            type: "showUpgrade",
                            data: "fileNum",
                        });
                    }
                };
                let pcOpenFile = (fullPath) => {
                    let userP = {
                        id: this.$store.getters.apiParam.id - 0,
                        token: this.$store.getters.apiParam.token,
                    };
                    let filePath = fullPath.match(/[^\/]+\/[^\/]+\/(.+)/) && fullPath.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
                    let params = Object.assign({ obj: filePath }, userP);
                    let fileName = filePath.match(/[^\/]*(?=\.eddx)/i)[0];
                    this.$edApi
                        .getDownFileAddress(params)
                        .then((signInfo) => {
                            //中文站用的oss，英文站用的aws，通过getSignature得到的数据不一样
                            let paramForPc;
                            if (this.internal) {
                                let { sign, exp } = signInfo.data;
                                sign = encodeURIComponent(sign);
                                paramForPc = {
                                    fileName: fileName,
                                    sign,
                                    exp,
                                    obj: fullPath,
                                    type: "open",
                                    from: "cloud",
                                    newFile: true,
                                    accessid: this.OSSAccessKeyId,
                                };
                            } else {
                                let { path, query } = signInfo.data;
                                paramForPc = {
                                    fileName: fileName,
                                    path,
                                    query,
                                    type: "open",
                                    from: "cloud",
                                    newFile: true,
                                    accessid: this.OSSAccessKeyId,
                                };
                            }
                            this.setPCOpenRecord(fullPath);
                            (<any>window).$qt.jsCallCloudFileOperate(JSON.stringify(paramForPc));
                        })
                        .catch(() => {
                            let ts: any = this;
                            ts.cleanMultipleStatus && ts.cleanMultipleStatus(true);
                            this.$store.commit("setPcLockStatus", false);
                            this.$edMessage.warning(this.$t("networkError"));
                        });
                };

                let trackSuffix = this.isAd ? `&from=ad` : "";
                let enterCanvasTrack = `&file_source=emptyFile&template_type=notTemplate&fromNull=1&diagram_type=default`;
                trackSuffix += enterCanvasTrack;

                this.$openFile({
                    params: {
                        newFileName: this.$t("newFile"),
                        libs: JSON.parse(localStorage.getItem("libs") || "[]"),
                        currentPath: this.nowPrefix,
                        folderId: this.nowPrefixId,
                        platform: this.$store.state.publicStore.runPlatform,
                    },
                    fileType: "emptyFile",
                    suffix: trackSuffix,
                    checkLimit: true,
                    limitRange: this.$store.state.publicStore.runPlatform,
                    limitCallback: limitCallback,
                    vip: this.vip,
                    isFullCouldSpace: this.isFullCouldSpace,
                }).then((obj) => {
                    this.deleteCacheByPath(this.nowPrefix); // 新建文件在编辑页完成，所以清除当前目录缓存
                    this.getFloder(this.nowPrefix); // 刷新云文档目录
                    if (this.isPC) {
                        pcOpenFile(obj.obj);
                        return;
                    }
                    this.$gaTrack("openFileProcess_enterCanvas", `fileSource: emptyFile}`);
                    this.sensors.track("generateCloudFile", {
                        Catalogues: "openFileProcess",
                        file_source: "emptyFile",
                    });
                    this.sensors.track("newFile", {
                        Catalogues: "openFileProcess",
                        new_file_type: "emptyFile",
                    });
                    if (this.openInTabs) {
                        location.href = obj.url;
                    }
                    newTab.location.href = obj.url;
                    this.$store.commit("setAppState", "create");
                    let timer = setInterval(() => {
                        try {
                            newTab.name;
                            newTab.name = obj.obj;
                            if (!newTab.name) {
                                this.$store.commit("setAppState", "");
                                clearInterval(timer);
                            }
                            if (!newTab.location.hash) {
                                this.$store.commit("setAppState", "");
                                clearInterval(timer);
                            }
                        } finally {
                        }
                    }, 1000);
                    // add open record
                    let key = obj.obj;
                    let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
                    if (!openTabs.includes(key)) {
                        openTabs.push(key);
                    }
                    this.$store.commit("addWin", newTab);
                    localStorage.setItem("openTabs", JSON.stringify(openTabs));
                });
            }

            // let list = []
            // let name = this.$t('newFile')

            // this.$store.dispatch('getUserLimit',this.isPC? "pc":"web").then(res => {
            //     if (res.data.is_over_limit) {
            //         if(!this.isPC){
            //             newTab.close();
            //             this.$store.commit("toPublicStatus", {
            //                 type: "showUpgrade",
            //                 data: 'fileNum'
            //             });
            //         }else{
            //             (<any>window).$qt.jsCallUpgradeToPremium(3);
            //             (<any>window).$qt.jsCallUploadfailReason && (<any>window).$qt.jsCallUploadfailReason('exceedsCloudFileNumber')
            //         }
            //     } else {

            //         // this.$store.dispatch('getFloder', {prefix: ''}).then(res => {
            //         //     let folderList = res.data.data.folders || []
            //         //     let filesList = res.data.data.files || []
            //         //     filesList.map(item => {
            //         //         let list = item.key.split('/')
            //         //         let name = list[list.length - 1]
            //         //         name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1]
            //         //         item.name = name
            //         //     })
            //         //     filesList = filesList.filter(item => {
            //         //         if (item.key.match(/.+eddx$/)) {
            //         //             return true
            //         //         }
            //         //         return false
            //         //     })

            //             this.filesList.forEach(file => {
            //                 let reg = new RegExp(`^${this.$t('newFile')}(\\d*)$`)
            //                 let res = file.name && file.name.match(reg)
            //                 if (res) {

            //                     if (res[1]) {
            //                         list.push(+res[1])
            //                     } else {
            //                         list.push(0)
            //                     }
            //                 }
            //             })
            //             list = list.sort((a, b) => a - b)
            //             if (list.includes(0)) {
            //                 for (let i = 0; i < list.length; i++) {
            //                     if (list[i] + 1 != list[i + 1]) {
            //                         name = this.$t('newFile') + (list[i] + 1)
            //                         break
            //                     }
            //                 }
            //             }
            //             this.$gaTrack('openFileProcess_enterCanvas', `fileSource: emptyFile}`)
            //             let path = this.path.length ? this.path.join("/") + "/" : ""
            //             if(this.isPC){
            //                 let libs = localStorage.getItem("libs");
            //                 let paramForPc = {
            //                     name,
            //                     newPath: path,
            //                     libs,
            //                     type: "new"
            //                 };
            //                 (<any>window).$qt.jsCallCloudFileOperate(JSON.stringify(paramForPc));
            //             }else{
            //                 let keyName = `${this.userInfo.user_name}/Personal/${path}${name}.eddx`
            //                 if(ts.isInclowdz) {
            //                     location.href = `${window.location.origin}${(<any>this.$router).options.base}app.html?` + ts.$zipFileName(`obj=${keyName}`) + "#create"
            //                 }
            //                 let fileObj = this.isAd ? 'obj=' + keyName + `&from=ad` : 'obj=' + keyName;
            //                 let enterCanvasTrack = `&file_source=emptyFile&template_type=notTemplate&fromNull=1&diagram_type=default`;
            //                 fileObj += enterCanvasTrack;
            //                 newTab.location.href = `${window.location.origin}${(<any>this.$router).options.base}app.html?` + ts.$zipFileName(fileObj) + "#create";
            //                 this.$store.commit("setAppState",'create');
            //                 let timer = setInterval(() => {
            //                     try{
            //                         newTab.name;
            //                         newTab.name = keyName;
            //                         if (!newTab.name) {
            //                             this.$store.commit("setAppState","");
            //                             clearInterval(timer)
            //                         }
            //                         if (!newTab.location.hash) {
            //                             this.$store.commit("setAppState","");
            //                             clearInterval(timer)
            //                         }
            //                     }finally{

            //                     }
            //                 }, 1000)
            //                 // this.$store.state.winobj[keyName] = newTab;
            //                 let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
            //                 if(!openTabs.includes(keyName)){
            //                     openTabs.push(keyName);
            //                 }
            //                 localStorage.setItem("openTabs",JSON.stringify(openTabs));
            //             }

            //         // })
            //     }
            // })
            // .catch(err => {
            //     console.log(err);
            // })
        }
        toDrag(e) {
            if (this.pcSaveInput) return;
            if (e.target.className && e.target.className.indexOf) {
                if (e.target.className.indexOf("files-item") != -1) {
                    // 拖拽文件
                    // if(this.selectFilesIndex.length <= 1){
                    //     this.selectFilesIndex = []
                    // }
                    this.dragFiles(e);
                }
            }
        }
        // file selector event
        selectAllFiles(type) {
            if (!type) {
                this.clearFile(1);
            } else {
                let arr = [];
                for (let i = 0; i < this.activeList.length; i++) {
                    arr.push(i);
                }
                this.$store.commit("setState", {
                    type: "selectFilesIndex",
                    data: arr,
                });
            }
        }
        cancelSelect() {
            this.clearFile();
        }
        modalEvent(obj) {
            // 处理多选移动/复制事件
            this.operateType = obj.eventType;
            this.moveEvent();
        }

        // star file & tag
        setStarFile(file = null) {
            this.closeFileMenu();
            let done = () => {
                window.postMessage(
                    {
                        type: "updateMyfile",
                        updateStarFile: true,
                    },
                    location.origin
                );
                let win = this.$store.state.openWinList;
                for (let i = 0; i < win.length; i++) {
                    win[i].postMessage(
                        {
                            type: "updateMyfile",
                            updateStarFile: true,
                        },
                        location.origin
                    );
                }
                this.refreshCache(this.nowPrefix);
            };
            if (file) {
                let type = file.info.start_tag ^ 1;
                this.$store
                    .dispatch("setStarFile", {
                        type: type,
                        id: file.info.id,
                        file_key: file.info.file_key,
                    })
                    .then((res) => {
                        file.info.start_tag = type;
                        done();
                    });
            } else {
                let type = this.selFiles[0].info.start_tag ^ 1;
                this.$store
                    .dispatch("setStarFile", {
                        type: type,
                        id: this.selFiles[0].info.id,
                        file_key: this.selFiles[0].info.file_key,
                    })
                    .then((res) => {
                        this.selFiles[0].info.start_tag = type;
                        done();
                    });
            }
        }

        get activeFileItemIndex() {
            return this.$store.state.activeFileItemIndex;
        }
        set activeFileItemIndex(v) {
            this.$store.commit("setState", {
                type: "activeFileItemIndex",
                data: v,
            });
        }
        clickTagStr(e) {
            if (this.isShowTag == true) {
                this.isShowTag = false;
                return;
            }
            // 手动触发 @Watch('isShowTag') 1
            this.isShowTag = false;
            // list布局重新计算标签菜单位置
            this.tagListAttr = e.target.getBoundingClientRect();
            this.tagListTop = this.tagListAttr.top;
            // list布局的标签宽度,无此属性列表位置存在遮挡
            this.menuWidth = 30;
            this.closeFileMenu();
            this.top = e.pageY - 230;
            this.left = e.pageX;
            if (document.documentElement.clientHeight - e.pageY < 236) {
                this.top -= 236;
            }
            if (document.documentElement.clientWidth - e.pageX < 313) {
                this.left -= 100;
            }
            // 手动触发 @Watch('isShowTag') 2
            this.$nextTick(() => {
                this.isShowTag = true;
            });
        }
        changeFileItemTagStr() {
            this.setFileItemTagStr(this.fileItemTagStr);
        }
        setFileItemTagStr(str) {
            let obj = {
                id: this.userInfo.user_id,
                token: this.userInfo.token,
                custom_tag: str + "",
                obj_id: this.activeList[this.activeFileItemIndex].info.id,
                file_key: this.activeList[this.activeFileItemIndex].info.file_key,
            };
            this.$edApi.setCustomTag(obj).then(() => {
                this.activeList[this.activeFileItemIndex].info.custom_tag = str;
                this.resetFileItemTag();
                this.refreshCache(this.nowPrefix);
            });
        }
        resetFileItemTag() {
            this.activeFileItemIndex = -1;
            this.fileItemTagStr = "";
        }
        toShowTag(e) {
            this.tagListAttr = e.target.getBoundingClientRect();
            this.tagListTop = this.tagListAttr.top;
            this.isShowTag = true;
        }
        @Watch("isShowTag")
        onshowTagChange(val: boolean) {
            if (val) {
                this.$nextTick(() => {
                    let ele: HTMLElement = <HTMLElement>this.$refs.tagList;
                    // let eleParent = document.getElementById('fileMenu');//整个列表
                    // let tagEle = document.getElementById('tagItem');//标签
                    // this.tagListTop = tagEle.offsetTop + eleParent.offsetTop;
                    // 超出屏幕重新计算高度
                    if (this.tagListTop + ele.offsetHeight > window.innerHeight) {
                        this.tagListTop = window.innerHeight - ele.offsetHeight - 20;
                    }
                });
            }
        }
        clearShowTag(e = null) {
            let dom = this.$refs.tagList as HTMLElement;
            if (e && dom && dom.contains(e.toElement)) return;
            this.isShowTag = false;
        }
        tagFunc(id) {
            this.clearShowTag();
            this.$store.commit("setState", {
                type: "activeFileItemIndex",
                data: this.selectFilesIndex[0],
            });
            if (id == 3) {
                this.$store.commit("setState", {
                    type: "showFileItemTagStrModal",
                    data: true,
                });
            } else {
                this.setFileItemTagStr(this.tagList[id].value);
            }
        }

        dragFiles(e) {
            // 拖拽文件
            console.log("toDrag");
            if (this.mouseEventType != -1) return;
            this.mouseEventType = 1;
            let scrollDom = this.$refs.filesScroll as HTMLElement,
                parentInfo = scrollDom.getBoundingClientRect(),
                baseScroll = scrollDom.scrollTop,
                parentL = parentInfo["x"],
                parentT = parentInfo["y"],
                baseMoveH = this.layoutMode === "list" ? 60 : 90;
            let toScrollTop = (step: number) => {
                let ts = this;
                this.scrollStep = step > 0 ? (baseMoveH - step) / 4 : baseMoveH / 4;
                if (!window["scrollEvent"]) {
                    let scrollFunc = function () {
                        scrollDom.scrollTop -= ts.scrollStep;
                        if (scrollDom.scrollTop > 0) {
                            ts.dragImgTop -= ts.scrollStep;
                        }
                        window["scrollEvent"] = requestAnimationFrame(scrollFunc);
                    };
                    window["scrollEvent"] = requestAnimationFrame(scrollFunc);
                }
            };
            document.onmousemove = (ev) => {
                let left = ev.clientX,
                    top = ev.clientY,
                    scrollT = scrollDom.scrollTop - baseScroll;
                if (e.clientX - left >= -2 && e.clientX - left <= 2 && e.clientY - top > -2 && e.clientY - top <= 2) return;
                if (top - parentT < baseMoveH) {
                    toScrollTop(top - parentT);
                } else {
                    if (window["scrollEvent"]) {
                        cancelAnimationFrame(window["scrollEvent"]);
                        window["scrollEvent"] = undefined;
                    }
                }
                if (!this.dragFlag) {
                    // 拖拽首次move，文件处理
                    let files = this.selectFilesIndex;
                    let fileIndex = e.target.dataset.index - 0;
                    if (fileIndex >= 0) {
                        if (!files.includes(fileIndex)) {
                            this.clearFile(1);
                            this.selectFile(fileIndex);
                        }
                    }
                }
                this.dragFlag = true;
                this.dragImgLeft = left - parentL + 5;
                this.dragImgTop = top - parentT + baseScroll + scrollT + 5;
            };
            document.onmouseup = () => {
                this.dragFlag = false;
                // this.dragItemList = [];
                console.log(this.dropFloderIndex);
                if (this.dropFloderIndex != -1) {
                    // 放置文件
                    this.dropFilesToFolder();
                } else {
                    this.dragFlag && this.clearFile();
                }
                if (window["scrollEvent"]) {
                    cancelAnimationFrame(window["scrollEvent"]);
                    window["scrollEvent"] = undefined;
                }
                if (this.mouseEventType == 1) {
                    document.onmouseup = null;
                    document.onmousemove = null;
                    this.mouseEventType = -1;
                }
            };
        }
        folderEnter(index) {
            if (this.dragFlag) {
                this.dropFloderIndex = index;
            }
        }
        folderLeave() {
            this.dropFloderIndex = -1;
        }
        dropFilesToFolder() {
            if (this.isOperating) return;
            let ids = [];
            let file_keys = [];
            let moveSucc = [];
            let failList = [];

            for (let i = 0; i < this.selectFilesIndex.length; i++) {
                if (this.isPrivate && this.filesList[this.selectFilesIndex[i]].info && this.filesList[this.selectFilesIndex[i]].info.file_key) {
                    ids.push(this.filesList[this.selectFilesIndex[i]].info.id);
                    file_keys.push(this.filesList[this.selectFilesIndex[i]].info.file_key);
                    moveSucc.push(this.selectFilesIndex[i]);
                } else if (this.filesList[this.selectFilesIndex[i]].info && this.filesList[this.selectFilesIndex[i]].info.id) {
                    ids.push(this.filesList[this.selectFilesIndex[i]].info.id);
                    moveSucc.push(this.selectFilesIndex[i]);
                } else {
                    failList.push(this.filesList[this.selectFilesIndex[i]].name);
                }
            }
            if (failList.length) {
                let names = failList.join(", ");
                this.$edMessage.warning({
                    content: names + " " + this.$t("errFile"),
                    duration: 6,
                });
            }
            if (!ids.length) {
                return;
            }
            this.isOperating = true;
            this.$store.commit("setState", { data: true, type: "showLoading" });
            let dropFolder = this.folderList[this.dropFloderIndex];
            // let filePath = dragItem.key.match(/Personal\/(.+)/)[1]
            let to = "";
            if (this.isPrivate) {
                to = dropFolder.prefix;
            } else {
                to = dropFolder.prefix.match(/Personal\/(.+)/)[1];
            }
            this.$store
                .dispatch("moveBatch", { ids, to, file_keys })
                .then((res) => {
                    this.clearFile();
                    this.folderLeave();
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    this.filesList = this.filesList.filter((v, k) => !moveSucc.includes(k));
                    this.isOperating = false;
                    this.updateCacheAfterMove(this.nowPrefix, to);
                    (<any>this).$edMessage.success(this.$t("moveto") + dropFolder.name);
                })
                .catch((err) => {
                    console.log(err);
                    this.isOperating = false;
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                });
        }

        //生命周期
        copyEvent(e, noTip: boolean = false) {
            if (this.renameShow || this.folderRenameShow) return;
            console.log(this.selFiles);
            if (document.activeElement.tagName !== "INPUT" && this.selectFilesIndex && this.selectFilesIndex.length != 0) {
                let names = [];
                this.operateIds = this.selFiles.reduce((re, item) => {
                    if (item.info) {
                        names.push(item.name);
                        re.push(item.info.id);
                    }
                    return re;
                }, []);
                this.operateType = "copy";
                this.operateNames = names;
                if (noTip) return;
                this.$edMessage.success(this.$t("copySucc"));
            }
        }
        cutEvent(e) {
            if (this.renameShow || this.folderRenameShow) return;
            if (document.activeElement.tagName !== "INPUT" && this.selectFilesIndex && this.selectFilesIndex.length != 0) {
                let names = [];
                this.operateIds = this.selFiles.reduce((re, item) => {
                    if (item.info) {
                        names.push(item.name);
                        re.push(item.info.id);
                    }
                    return re;
                }, []);
                this.operateType = "cut";
                this.operateNames = names;
                this.$edMessage.success(this.$t("cutSucc"));
            }
        }
        pasteEvent(e) {
            if (this.renameShow || this.folderRenameShow) return;
            if (!this.isOperating) {
                if (this.operateType && document.activeElement.tagName !== "INPUT") {
                    if (this.operateIds && this.operateIds.length !== 0) {
                        console.log(123);
                        let indexs = [];
                        let fNames = this.activeList.map((item) => {
                            return item.name;
                        });
                        this.operateNames.forEach((item, index) => {
                            if (fNames.includes(item)) {
                                indexs.push(index);
                            }
                        });
                        if (indexs.length) {
                            this.operateSameIndexs = indexs;
                            this.samePathModal = true;
                        } else {
                            this.toPaste(true);
                        }
                    }
                }
            }
        }
        get showFileNew() {
            return !(this.isTeamsApp && !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/));
        }
        get workBrenchIndex() {
            return this.$store.state.workBrenchIndex;
        }
        keyDownEvent(e) {
            if (this.workBrenchIndex != 1) return; // 非云文档页面，拦截事件
            let isMac = navigator.userAgent.indexOf("Mac") !== -1;
            this.ctrldown = isMac ? e.metaKey : e.ctrlKey;
            if (e.keyCode == 46) {
                if (this.renameShow || this.folderRenameShow) return;
                if (this.selectFilesIndex !== []) {
                    this.delFiles();
                }
                if (this.selectFolderIndex !== null) {
                    this.delFolder();
                }
            }
        }
        activated() {
            this.clearFile();
        }
        receiveMessage(event) {
            if (event.origin !== location.origin) return;
            if (event.data.type && event.data.type == "updateCloudFileStar") {
                // 更新最近浏览文件
                if (event.data.fileID) {
                    this.$bus.$emit("changeFileInfo", {
                        id: event.data.fileID,
                        key: "start_tag",
                        value: event.data.status,
                    });
                }
            }
        }

        toCreateCopy() {
            this.$track("files", "createCopy");

            this.copyEvent(null, true);

            this.toPaste(true, false, true);
        }
        toCopy() {
            this.$track("files", "copy", this.selectFilesIndex.length);
            document.execCommand("copy");
        }
        toCut() {
            this.$track("files", "cut", this.selectFilesIndex.length);
            document.execCommand("cut");
        }
        get selectMovePrefix() {
            return this.$store.state.selectMovePrefix;
        }
        set selectMovePrefix(v) {
            this.$store.commit("setState", {
                type: "selectMovePrefix",
                data: v,
            });
        }
        setModalBtnLoading(val: boolean) {
            let loadingObj: object = {},
                key = this.operateType + "Loading";
            loadingObj[key] = val;
            this.$store.commit("setCloudFileStatus", loadingObj);
        }
        moveEvent() {
            if (this.isOperating) return;
            this.isOperating = true;
            this.$track("cloudfile", "Right click menu", this.operateType);
            let prefix = this.selectMovePrefix;
            this.setModalBtnLoading(true);
            // 判断操作文件还是操作文件夹
            if (!!this.selectFolder) {
                let from = this.selectFolder.prefix ? this.selectFolder.prefix.split("/").slice(2).join("/") : "/";
                let to = prefix ? prefix.split("/").slice(2).join("/") : "";
                if (this.isPrivate) {
                    from = this.selectFolder.prefix;
                    to = prefix;
                }
                let toName = to;
                if (to === "") {
                    toName = this.$t("personal");
                } else if (to.endsWith("/")) {
                    toName = toName.slice(0, -1);
                }
                // 判断移动文件夹还是复制文件夹
                // 移动文件夹：this.operateType === 'move' ,进而拼接成moveDir等
                // 移动文件夹：this.operateType === 'copy' ,进而拼接成copyDir等
                this.$store
                    .dispatch(this.operateType + "Dir", {
                        from,
                        to: to + from.split("/").slice(-2).join("/"),
                        platform: this.isPC ? "pc" : "web",
                    })
                    .then((res) => {
                        this.closeFileMenu();
                        this.closeModal();
                        if (
                            res.data.msg == "folder contain different file type, could not delete" ||
                            res.data.msg == "folder contain different file type, could not copy"
                        ) {
                            (<any>this).$edMessage.warning(this.$t("cantDel"));
                            return;
                        }
                        this.isOperating = false;
                        if (res.data.status == "success") {
                            // if(from.split('/').slice(-2).join("/") !== to && this.operateType === 'move')
                            //     this.folderList.splice(this.selectFolderIndex, 1);
                            this.setModalBtnLoading(false);
                            (<any>this).$edMessage.success(this.$t(this.operateType + "DirSucc") + toName);
                            this.updateCacheAfterMove(this.nowPrefix, to);
                        } else {
                        }
                        this.reload();
                        // this.$store.commit('setState', {data: false, type: 'showLoading'})
                        this.selectFolderIndex = null;
                        this.cancelSelect();
                    })
                    .catch((error) => {
                        if (error === "storage space not enough") {
                            this.$edMessage.warning(this.$t("spaceNotEnough"));
                        } else if (error === "folder contain different file type, could not copy") {
                            (<any>this).$edMessage.warning(this.$t("cantDel"));
                        } else {
                            this.$edMessage.warning(this.$t(this.operateType + "Fail"));
                        }
                        this.closeFileMenu();
                        this.closeModal();
                        this.setModalBtnLoading(false);
                        this.isOperating = false;
                    });
            } else if (this.selectFilesIndex && this.selectFilesIndex.length !== 0) {
                let to = prefix ? prefix.split("/").slice(2).join("/") : "/";
                if (this.isPrivate) {
                    to = prefix;
                }
                let moveSucc = [];
                let failList = [];
                let ids = [];
                let file_keys = [];
                for (let i = 0; i < this.selectFilesIndex.length; i++) {
                    if (this.isPrivate && this.activeList[this.selectFilesIndex[i]].info && this.activeList[this.selectFilesIndex[i]].info.file_key) {
                        ids.push(this.activeList[this.selectFilesIndex[i]].info.id);
                        file_keys.push(this.activeList[this.selectFilesIndex[i]].info.file_key);
                        moveSucc.push(this.selectFilesIndex[i]);
                    } else if (this.activeList[this.selectFilesIndex[i]].info && this.activeList[this.selectFilesIndex[i]].info.id) {
                        ids.push(this.activeList[this.selectFilesIndex[i]].info.id);
                        moveSucc.push(this.selectFilesIndex[i]);
                    } else {
                        failList.push(this.activeList[this.selectFilesIndex[i]].name);
                    }
                }

                // let names=[];
                // console.log(this.selFiles)
                // let ids = this.selFiles.reduce((re,item)=>{
                //     if(item.info){
                //         names.push(item.name);
                //         re.push(item.info.id)
                //     }
                // })

                if (failList.length) {
                    let names = failList.join(", ");
                    this.$edMessage.warning({
                        content: names + " " + this.$t("errFile"),
                        duration: 6,
                    });
                }

                this.isOperating = false;

                if (!ids.length) return;

                let toName = to;
                if (to === "/") {
                    toName = this.$t("personal");
                } else if (to.endsWith("/")) {
                    toName = to.slice(0, -1);
                }
                // 判断移动文件还是复制文件
                // 移动文件：this.operateType === 'move' ,进而拼接成moveBatch等
                // 移动文件：this.operateType === 'copy' ,进而拼接成copyBatch等
                let other = this.operateType === "copy" ? "To" : ""; // 为了避免影响之前的复制副本的功能，故新增 copySuccTo 的文字提示信息
                this.$store
                    .dispatch(this.operateType + "Batch", {
                        ids,
                        file_keys,
                        to,
                        platform: this.isPC ? "pc" : "web",
                    })
                    .then((res) => {
                        this.$edMessage.success(this.$t(this.operateType + "Succ" + other) + toName);
                        // if((this.path.join("/")+"/" !== to && this.operateType === 'copy') || (this.path.join("/")+"/" === to && this.operateType === 'copy')){
                        //     (this.operateType === 'move') && (this.filesList = this.filesList.filter((v, k) => !this.selectFilesIndex.includes(k)));
                        //     this.selectFilesIndex = [];
                        // }else{
                        this.updateCacheAfterMove(this.nowPrefix, to);
                        this.reload();
                        // }
                        this.closeFileMenu();
                        this.closeModal();
                        this.setModalBtnLoading(false);
                        this.isOperating = false;
                        this.cancelSelect();
                        this.$store.dispatch("getUserInfo");
                    })
                    .catch((error) => {
                        if (error === "storage space not enough") {
                            this.$edMessage.warning(this.$t("spaceNotEnough"));
                            this.$checkAuth({
                                type: "cloudSpace",
                                buyTrigger: "cloudSpacePop",
                                pcParams: { newUpgrade: 6, upgrade: 0 },
                            });
                        } else {
                            this.$edMessage.warning(this.$t(this.operateType + "Fail"));
                        }
                        this.closeFileMenu();
                        this.closeModal();
                        this.setModalBtnLoading(false);
                        this.isOperating = false;
                    });
            }
        }
        toPaste(renameIfDup: boolean = true, skipSame: boolean = false, createCopy: boolean = false) {
            let type = this.operateType;
            let ids = this.operateIds;

            if (this.isOperating) return;

            if (skipSame) {
                ids = ids.filter((item, index) => {
                    return !this.operateSameIndexs.includes(index);
                });
            }
            if (!ids.length) {
                this.samePathModal = false;
                this.pasteLoading = 0;
                return;
            }
            let to = this.path.join("/") + "/";
            this.isOperating = true;

            // let filePath = dragItem.key.match(/Personal\/(.+)/)[1]
            if (type == "copy") {
                this.$store
                    .dispatch("copyBatch", {
                        ids,
                        to,
                        cover: renameIfDup ? 0 : 1,
                        platform: this.isPC ? "pc" : "web",
                    })
                    .then((res) => {
                        this.samePathModal = false;
                        this.pasteLoading = 0;
                        if (createCopy) {
                            this.$edMessage.success(this.$t("createCopySucc"));
                        } else {
                            this.$edMessage.success(this.$t("pasteSucc"));
                        }
                        if (this.path.length === 0) {
                            this.getFloder("", res.data && res.data.data ? res.data.data : null);
                        } else {
                            this.getFloder(to, res.data && res.data.data ? res.data.data : null);
                        }
                        this.updateCacheAfterMove(null, to);

                        // this.operateIds = [];
                        // this.operateType = "";
                        // this.operateNames = [];
                        this.isOperating = false;
                    })
                    .catch((error) => {
                        this.samePathModal = false;
                        this.pasteLoading = 0;
                        this.isOperating = false;
                        if (error == "spaceOverLimit") {
                            this.$edMessage.warning(this.$t("spaceOverLimit"));
                            this.$checkAuth({
                                type: "cloudSpace",
                                buyTrigger: "cloudSpacePop",
                                pcParams: { newUpgrade: 6, upgrade: 0 },
                            });
                        } else {
                            this.$edMessage.warning(this.$t("pasteFail"));
                        }
                    });
            } else if (type == "cut") {
                this.$store
                    .dispatch("moveBatch", {
                        ids,
                        to,
                        cover: renameIfDup ? 1 : 0,
                        platform: this.isPC ? "pc" : "web",
                    })
                    .then((res) => {
                        this.samePathModal = false;
                        this.pasteLoading = 0;
                        if (createCopy) {
                            this.$edMessage.success(this.$t("createCopySucc"));
                        } else {
                            this.$edMessage.success(this.$t("pasteSucc"));
                        }
                        if (this.path.length === 0) {
                            this.getFloder("", res.data && res.data.data ? res.data.data : null);
                        } else {
                            this.getFloder(to, res.data && res.data.data ? res.data.data : null);
                        }
                        this.updateCacheAfterMove(this.nowPrefix, to);
                        this.operateIds = [];
                        this.operateType = "";
                        this.operateNames = [];
                        this.isOperating = false;
                    })
                    .catch((error) => {
                        this.samePathModal = false;
                        this.pasteLoading = 0;
                        this.$edMessage.warning(this.$t("pasteFail"));
                        this.isOperating = false;
                    });
            }
        }
        openFilessss() {
            let ts: any = this;
            let list = JSON.parse(JSON.stringify(this.selFiles));
            if (list.length > 20) list.length = 20;
            ts.openMultipleFiles(list);
        }

        created() {
            this.$nextTick(() => {
                this.isPC && this.$store.commit("setState", { data: 1, type: "selectId" });
            });
            this.$bus.$on("toCreateFile", () => {
                this.toCreateFile();
            });
            this.$bus.$on("jump", (data) => {
                let key = "",
                    path = "";
                if (this.isPrivate) {
                    key = data.key.match(/[^\/]*$/)[0];
                    path = data.prefix;
                    let pathArr = data.prefix.split("/");
                    pathArr = pathArr.filter((item) => item != "");
                    this.path = pathArr;
                } else {
                    key = data.key.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
                    let pathArr = key.split("/");
                    let name = pathArr.pop();
                    this.path = pathArr;
                    if (pathArr.length > 0) {
                        path = pathArr.join("/") + "/";
                    }
                }
                this.getFloder(path, null, true, () => {
                    for (let i = 0; i < this.filesList.length; i++) {
                        if (data.key == this.filesList[i].key) {
                            this.selectFile(i);
                        }
                    }
                    this.$nextTick(() => {
                        let target = this.$refs.filesBoxList as HTMLElement;
                        let dom = target && target.children[this.$store.state.selectFilesIndex[0]];
                        console.log(dom);
                        if (dom) dom.scrollIntoView({ behavior: "smooth", block: "center" });
                    });
                });
            });
        }
        mounted() {
            if (this.pcNoLogin) {
                this.toPCLogin();
            }
            window["test"] = this;
            if (!["name", "time", "size"].includes(this.orderName)) {
                this.orderName = "time";
            }
            // this.$store.commit('setState', {data: 1, type: 'selectId'})
            let dom: any = document.querySelector(".files-container");
            dom.onscroll = () => {
                this.closeFileMenu();
            };
            // document.addEventListener('copy',this.copyEvent)

            // document.addEventListener('cut',this.cutEvent)
            // document.addEventListener('paste',this.pasteEvent)
            document.addEventListener("keydown", this.keyDownEvent);
            window.addEventListener("message", this.receiveMessage);
            window.addEventListener("resize", this.scrollFit);
            let con = <HTMLElement>this.$refs.filesScroll;
            con.addEventListener("scroll", this.scrollToAdd);
            window.onmessage = (e) => {
                if (!e.data) return;
                if (e.data.type == "updateFiles") {
                    if (!this.$validateLogin()) return;
                    this.host = this.userInfo.user_name + "/Personal";
                    if (this.path) {
                        if (this.path.length == 0) {
                            this.getFloder("", null, true);
                        } else {
                            this.getFloder(this.path.join("/") + "/", null, true);
                        }
                    }
                }
            };

            if (this.userInfo) {
                this.init();
            } else {
                this.$bus.$on("loginSucc-files", () => {
                    this.init();
                });
            }
            this.$bus.$on("refreshEv", () => {
                this.reload();
            });
            this.$bus.$on("refreshList", () => {
                // 导入刷新列表
                this.getFloder(this.nowPrefix, null, true);
            });
            this.$bus.$on("changeFileInfo", (obj) => {
                console.log("get changeFileInfo");
                for (let i = 0; i < this.activeList.length; i++) {
                    if (this.activeList[i].info && this.activeList[i].info.id == obj.id) {
                        this.activeList[i].info[obj.key] = obj.value;
                        break;
                    }
                }
                if (obj.path != undefined) {
                    this.refreshCache(obj.path);
                }
            });
            this.$bus.$on("openFilesConfirm", (status) => {
                console.log("openFilesConfirm", status);
                status && this.openFilessss();
            });
            (<any>window).$qt && (<any>window).$qt.jsCallWebUIDisplay && (<any>window).$qt.jsCallWebUIDisplay(); // 通知客户端ui渲染完成
        }
        beforeDestroy() {
            this.path = []; // 离开时清除path
            this.$bus.$off("loginSucc-files");
            this.$bus.$off("refreshEv");
            this.$bus.$off("refreshList");
            this.$bus.$off("jump");
            this.$bus.$off("changeFileInfo");
            this.$bus.$off("openFilesConfirm");

            console.log("beforeDes");
            this.clearFile();
            this.closeFileMenu();
            document.removeEventListener("keydown", this.keyDownEvent);
            document.removeEventListener("message", this.receiveMessage);
            window.onmessage = null;
            let con = <HTMLElement>this.$refs.filesScroll;
            con.removeEventListener("scroll", this.scrollToAdd);
            window.removeEventListener("resize", this.scrollFit);
        }
        init() {
            this.host = this.userInfo.user_name + "/Personal";
            this.getFloder("", null, true);
        }

        get userInfo() {
            return this.$store.state.userInfo;
        }

        coverError(e) {
            let lang = this.lang == "zh" ? "zh" : "en";
            e.target.src = require(`@/home/assets/img/files/default-files-${lang}.svg`);
        }

        listcoverError(e) {
            e.target.src = require("@/home/assets/img/files/file-list.svg");
        }

        searchBack() {
            this.searchMode = false;
            this.searchValue = "";
            this.path = [];
            this.getFloder("");
        }

        enter(e) {
            if (e.keyCode == 13) {
                this.search();
            }
        }

        search() {
            this.$track("files", "search");
            this.sensors.track("searchCloudFile", {
                Catalogues: "Workbench",
            });
            this.cancelSelect();
            if (this.searchValue) {
                this.searchMode = true;
                this.searchList = [];
                this.$store.commit("setState", { data: true, type: "showLoading" });
                if (this.isPC) {
                    (<any>window).$qt.jsCallUploadData &&
                        (<any>window).$qt.jsCallUploadData(
                            JSON.stringify({
                                type: "Open",
                                action: "searchCloudFile",
                            })
                        );
                }
                this.$store
                    .dispatch("searchFile", { value: this.searchValue.trim() })
                    .then((res) => {
                        if (this.isPrivate) {
                            res.data.data.map((item) => {
                                item.name = item.info.name;
                                item.filePath = item.prefix ? this.$t("personal") + ">" + item.prefix : this.$t("personal");
                                return item;
                            });
                        } else {
                            res.data.data.map((item) => {
                                let filePath: any = [];
                                filePath = item.key.match(/[^\/]+\/[^\/]+\/(.+)/) && item.key.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
                                filePath = filePath.split("/");
                                let name = filePath.pop();
                                filePath = filePath.length ? this.$t("personal") + ">" + filePath.join(">") : this.$t("personal");
                                name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1];
                                item.name = name;
                                item.filePath = filePath;
                            });
                        }

                        this.searchList = res.data.data;
                        if (this.searchList.length == 0) {
                            (<any>this).$edMessage.error(this.$t("notFind"));
                        } else {
                            if (this.isPC) {
                                (<any>window).$qt.jsCallUploadData &&
                                    (<any>window).$qt.jsCallUploadData(
                                        JSON.stringify({
                                            type: "Open",
                                            action: "searchCloudResult",
                                        })
                                    );
                            } else {
                                this.sensors.track("searchCloudResult", {
                                    Catalogues: "Workbench",
                                });
                            }
                        }
                        this.$store.commit("setState", { data: false, type: "showLoading" });
                    })
                    .catch((err) => {
                        this.searchList = [];
                        (<any>this).$edMessage.error(this.$t("notFind"));
                        this.$store.commit("setState", { data: false, type: "showLoading" });
                    });

                // this.searchMode = true
                // let list = []
                // this.searchValue = this.searchValue.trim()
                // let re = new RegExp(this.searchValue,"gim")
                // this.filesList.forEach(item => {
                //     if (item.name.match(re)) {
                //         list.push(item)
                //     }
                // })
                // this.searchList = list
            } else {
                this.searchMode = false;
            }
        }

        setLayout() {
            this.$track("files", "toggle view");
            this.$store.commit("changeLayout");
            this.clearFile();
            this.clearFolder();
        }
        clickOrder(name) {
            this.$track("files", "sort by", name);
            let change = name !== this.orderName;
            this.setOrder(name);
            if (!change) {
                this.order();
            }
        }

        sortByOrder(name, list) {
            if (name === "time") {
                if (this.rotate == 180) {
                    list = list.sort((a, b) => new Date(a.lastModified).getTime() - new Date(b.lastModified).getTime());
                } else {
                    list = list.sort((a, b) => new Date(b.lastModified).getTime() - new Date(a.lastModified).getTime());
                }
            } else if (name === "size") {
                if (this.rotate == 180) {
                    list = list.sort((a, b) => a.size - b.size);
                } else {
                    list = list.sort((a, b) => b.size - a.size);
                }
            } else if (name === "name") {
                if (this.rotate == 0) {
                    list = list.sort((a, b) => naturalsort(a.name, b.name));
                } else {
                    list = list.sort((a, b) => naturalsort(b.name, a.name));
                }
            } else {
                this.orderName = "time";
                if (this.rotate == 180) {
                    list = list.sort((a, b) => new Date(a.lastModified).getTime() - new Date(b.lastModified).getTime());
                } else {
                    list = list.sort((a, b) => new Date(b.lastModified).getTime() - new Date(a.lastModified).getTime());
                }
            }
            return list;
        }
        setOrder(name) {
            this.cancelSelect();
            this.orderName = name;
            if (this.tempCacheIndex != -1) {
                let tempList = this.cloudCache[this.tempCacheIndex].files;
                this.cloudCache[this.tempCacheIndex].files = this.sortByOrder(name, tempList);
                this.getFloder(this.nowPrefix);
                if (name === "name") {
                    if (this.rotate == 0) {
                        this.folderList = this.folderList.sort((a, b) => naturalsort(a.name, b.name));
                    } else {
                        this.folderList = this.folderList.sort((a, b) => naturalsort(b.name, a.name));
                    }
                    this.updateCache(null, this.folderList);
                }
            } else {
                if (name === "time") {
                    if (this.rotate == 180) {
                        this.filesList = this.filesList.sort((a, b) => new Date(a.lastModified).getTime() - new Date(b.lastModified).getTime());
                    } else {
                        this.filesList = this.filesList.sort((a, b) => new Date(b.lastModified).getTime() - new Date(a.lastModified).getTime());
                    }
                } else if (name === "size") {
                    if (this.rotate == 180) {
                        this.filesList = this.filesList.sort((a, b) => a.size - b.size);
                    } else {
                        this.filesList = this.filesList.sort((a, b) => b.size - a.size);
                    }
                } else if (name === "name") {
                    if (this.rotate == 0) {
                        this.filesList = this.filesList.sort((a, b) => naturalsort(a.name, b.name));
                        this.folderList = this.folderList.sort((a, b) => naturalsort(a.name, b.name));
                    } else {
                        this.filesList = this.filesList.sort((a, b) => naturalsort(b.name, a.name));
                        this.folderList = this.folderList.sort((a, b) => naturalsort(b.name, a.name));
                    }
                    this.updateCache(null, this.folderList);
                } else {
                    this.orderName = "time";
                    if (this.rotate == 180) {
                        this.filesList = this.filesList.sort((a, b) => new Date(a.lastModified).getTime() - new Date(b.lastModified).getTime());
                    } else {
                        this.filesList = this.filesList.sort((a, b) => new Date(b.lastModified).getTime() - new Date(a.lastModified).getTime());
                    }
                }
            }
            localStorage.setItem("max_sort", this.orderName);
        }

        order() {
            this.cancelSelect();
            if (this.rotate == 0) {
                this.rotate = 180;
                if (this.orderName == "name") {
                    this.folderList = this.folderList.sort((a, b) => naturalsort(b.name, a.name));
                    this.updateCache(null, this.folderList);
                }
            } else {
                this.rotate = 0;
                if (this.orderName == "name") {
                    this.folderList = this.folderList.sort((a, b) => naturalsort(a.name, b.name));
                    this.updateCache(null, this.folderList);
                }
            }
            if (this.tempCacheIndex != -1) {
                let tempList = this.cloudCache[this.tempCacheIndex].files;
                this.cloudCache[this.tempCacheIndex].files = this.sortByOrder(this.orderName, tempList);
                this.getFloder(this.nowPrefix);
            } else {
                if (this.rotate == 0) {
                    if (this.orderName == "name") {
                        this.filesList = this.filesList.sort((a, b) => naturalsort(a.name, b.name));
                    } else if (this.orderName == "time") {
                        this.filesList = this.filesList.sort((a, b) => new Date(b.lastModified).getTime() - new Date(a.lastModified).getTime());
                    } else if (this.orderName == "size") {
                        this.filesList = this.filesList.sort((a, b) => b.size - a.size);
                    }
                } else {
                    if (this.orderName == "name") {
                        this.filesList = this.filesList.sort((a, b) => naturalsort(b.name, a.name));
                    } else if (this.orderName == "time") {
                        this.filesList = this.filesList.sort((a, b) => new Date(a.lastModified).getTime() - new Date(b.lastModified).getTime());
                    } else if (this.orderName == "size") {
                        this.filesList = this.filesList.sort((a, b) => a.size - b.size);
                    }
                }
            }
            localStorage.setItem("max_order", this.rotate.toString());
        }

        setPath(index) {
            console.log(this.path);
            if (this.showPathBox) {
                this.showPathBox = false;
                document.removeEventListener("click", this.closePathBox);
            }
            this.clearFolder();
            this.clearFile();
            if (index === null) {
                this.getFloder("");
                this.path = [];
            } else {
                let len = this.path.length - 1 - index;
                for (let i = 0; i < len; i++) {
                    this.path.pop();
                }
                let prefix = this.path.join("/") + "/";
                this.getFloder(prefix);
            }
        }

        openFolder(item) {
            if (this.mulSelectMode) return;
            this.sensors.track("openCloud_Folder", {
                Catalogues: "Workbench",
            });
            this.closeFileMenu();
            this.clearFolder();
            this.clearFile();
            this.path.push(item.name);
            let prefix = this.path.join("/") + "/";
            this.getFloder(prefix);
            if (this.isPC) {
                if (this.pcSaveInput) {
                    // (<any>window).$qt.jsCallUploadData && (<any>window).$qt.jsCallUploadData(JSON.stringify({
                    //     type: "S004_Save_8",
                    //     action: "SL028_Click_Cloud_Folder",
                    // }));
                } else {
                    (<any>window).$qt.jsCallUploadData &&
                        (<any>window).$qt.jsCallUploadData(
                            JSON.stringify({
                                type: "Open",
                                action: "openCloud_Folder",
                            })
                        );
                }
            }
        }

        createFolder() {
            if (!this.$validateLogin()) return;
            let baseName = this.checkFolderName(this.$t("createFolder").toString(), this.folderList);
            let item = {
                name: baseName,
                prefix: this.path.length
                    ? this.host + "/" + this.path.join("/") + "/" + this.$t("createFolder").toString() + "/"
                    : this.host + "/" + this.$t("createFolder").toString() + "/",
                type: "created",
            };
            if (this.isPC && this.pcSaveInput) {
                // (<any>window).$qt.jsCallUploadData && (<any>window).$qt.jsCallUploadData(JSON.stringify({
                //     type: "S004_Save_8",
                //     action: "SL029_Create_Cloud_Folder",
                // }));
            }
            // this.folderList.push(item)
            this.renameValue = item.name;
            // this.folderRenameShow = this.folderList.length - 1
            this.folderRenameShow = true;
            this.$nextTick(() => {
                let dom = <HTMLInputElement>document.getElementById("renameInput");
                dom.select();
                getSelection().collapseToEnd();
            });
            this.selectFolder = item;
            // setTimeout(() => {
            //     let dom = <HTMLInputElement> document.querySelector('.folder-rename')
            //     dom.select()
            // })
        }

        editFolder(e, item, index) {
            this.closeFileMenu();
            if (this.mulSelectMode) return; // 多选模式下禁止编辑文件夹
            this.top = e.pageY;
            this.left = e.pageX;
            if (document.documentElement.clientHeight - e.pageY < 236) {
                this.top -= 236;
            }
            if (document.documentElement.clientWidth - e.pageX < 100) {
                this.left -= 100;
            }
            this.contextmenuBoxShow = false;
            this.folderMenuBoxShow = true;
            this.selectFolderIndex = index;
            this.selectFolder = item;
        }
        // 选中文件夹
        selectFloder(item, index) {
            if (this.mulSelectMode) return;
            this.clearFile();
            this.selectFolderIndex = index;
            this.selectFolder = item;
            console.log(this.selectFolderIndex, this.selectFolder);
        }
        clearFolder() {
            this.selectFolderIndex = null;
            this.selectFolder = null;
        }
        clearFile(keepMulSelectMode = 0) {
            this.selectFilesIndex = [];
            !keepMulSelectMode && (this.mulSelectMode = false);
        }
        closeFileMenu() {
            this.folderMenuBoxShow = false;
            this.contextmenuBoxShow = false;
            this.closeTopMenu();
        }
        closeTopMenu() {
            this.showTopMenu = false;
        }
        closeModal() {
            this.showFolderModal = false;
            this.isFolder = false;
            this.selectMovePrefix = "";
        }
        menuOpenFiles(e) {
            this.$track("cloudfile", "Right click menu", "open");
            this.openFiles(e);
        }
        add2Template() {
            console.log("add custom template", this.selFiles[0]);
            let showUpgradeVip = () => {
                this.$store.commit("toPublicStatus", {
                    type: "showUpgrade",
                    data: "personalTemplateNumber",
                });
            };
            let fileItem = this.selFiles[0];
            if (!fileItem || !fileItem.info) {
                this.$edMessage.error(this.$t("errorFile"));
                return;
            }
            this.$edApi
                .addCustomTemplate({
                    user_id: this.userInfo.user_id,
                    token: this.userInfo.token,
                    data: {
                        obj_id: fileItem.info.id,
                        platform: this.$store.state.publicStore.runPlatform,
                        file_key: fileItem.info.file_key || "",
                    },
                })
                .then((e) => {
                    if (e == "success") {
                        this.$edMessage.success(this.$t("addTemplateSucc"));
                    } else if (e == "error") {
                        showUpgradeVip();
                    }
                    console.log(e);
                })
                .catch((err) => {
                    console.log(err);
                    if (err) {
                        showUpgradeVip();
                    }
                });
        }

        // 批量打开文件
        mutOpenInfo = {
            opening: false,
            index: 0,
            total: 0,
        };
        mutOpenList = [];
        openMultipleFiles(fileList) {
            // 批量打开文件
            if (!this.isPC) return;
            console.log("multiple open file");
            this.mutOpenList = fileList;
            this.openFiles(fileList[0]);
            this.mutOpenInfo.total = fileList.length;
            this.mutOpenInfo.index = 0;
            this.mutOpenInfo.opening = true;
            // for(let i = 0; i < fileList.length; i++) {
            //     this.openFiles(fileList[i]);
            // }
        }
        cleanMultipleStatus(force = false) {
            console.log(this.mutOpenInfo.index, this.mutOpenInfo.total);
            if (force || this.mutOpenInfo.index == this.mutOpenInfo.total) {
                this.mutOpenList = [];
                this.mutOpenInfo = {
                    opening: false,
                    index: 0,
                    total: 0,
                };
            }
        }
        get pcLock() {
            return this.$store.state.pcLockStatus;
        }
        @Watch("pcLock")
        watchPcLock(v) {
            console.log("pcLockStatus", v);
            !v && this.cleanMultipleStatus(); // pc修改状态为false，检查是否完成批量打开
            if (!v && this.mutOpenInfo.opening && this.mutOpenInfo.index != this.mutOpenInfo.total) {
                this.mutOpenInfo.index++;
                setTimeout(() => {
                    this.openFiles(this.mutOpenList[this.mutOpenInfo.index]);
                }, 10);
            }
        }
        menuShare() {
            // 国内分享位绑定手机号先绑定手机号
            this.$track("cloudfile", "Right click menu", "share");
            this.share(null);
        }
        folderRename() {
            this.$track("cloudfile", "Right click menu", "rename folder");
            this.renameValue = this.selectFolder.name;
            this.folderRenameShow = true;
            this.$nextTick(() => {
                let dom = <HTMLInputElement>document.getElementById("renameInput");
                dom.select();
                getSelection().collapseToEnd();
            });
            // setTimeout(() => {
            //     let dom = <HTMLInputElement> document.querySelector('.folder-rename')
            //     dom.select()
            // })
        }

        needPCUpdate(version, title, content, okText, cancelText) {
            if (this.isPC && !this.$isBiggerVersion(version)) {
                this.$Modal.confirm({
                    title,
                    content,
                    okText,
                    cancelText,
                    onOk: () => {
                        let updateLink = this.internal
                            ? "https://www.edrawsoft.cn/download-edrawmax.html"
                            : ["en", "zh", "tw"].includes(this.lang)
                            ? "https://www.edrawsoft.com/download-edrawmax.html"
                            : `https://www.edrawsoft.com/${this.lang}/download-edrawmax.html`;
                        if (this.isPC) {
                            (<any>window).$qt && (<any>window).$qt.jsCallOpenUrl && (<any>window).$qt.jsCallOpenUrl(updateLink);
                        } else {
                            window.open(updateLink);
                        }
                    },
                    onCancel: () => {},
                });
                return true;
            }
            return false;
        }

        downloadFiles() {
            this.$track("cloudfile", "Right click menu", "download");
            let ts: any = this;
            if (this.selFiles.length === 1) {
                if (this.isPC) {
                    this.$edMessage.loading({
                        content: <string>this.$t("fileDownloading"),
                        duration: 0,
                    });
                    let item = this.selFiles[0];
                    let userP = this.$store.getters.apiParam;
                    let filePath = item.key.match(/[^\/]+\/[^\/]+\/(.+)/) && item.key.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
                    let params = Object.assign({ obj: filePath }, userP);
                    this.$edApi
                        .getDownFileAddress(params)
                        .then((signInfo) => {
                            let obj = item.key;
                            //中文站用的oss，英文站用的aws，通过getSignature得到的数据不一样
                            let paramForPc;
                            if (this.internal) {
                                let { sign, exp } = signInfo.data;
                                sign = encodeURIComponent(sign);
                                paramForPc = {
                                    fileName: item.name,
                                    sign,
                                    exp,
                                    obj,
                                    type: "download",
                                    accessid: this.OSSAccessKeyId,
                                };
                            } else {
                                let { path, query } = signInfo.data;
                                paramForPc = {
                                    fileName: item.name,
                                    path,
                                    query,
                                    type: "download",
                                    accessid: this.OSSAccessKeyId,
                                };
                            }
                            (<any>window).$qt.jsCallCloudFileOperate(JSON.stringify(paramForPc));
                        })
                        .catch(() => {
                            this.$edMessage.warning(this.$t("networkError"));
                        });
                } else {
                    this.$store.dispatch("downloadFiles", this.selFiles[0]).then((res) => {
                        let aLink = document.createElement("a");
                        let blob = res.data;
                        let event = new MouseEvent("click", {
                            view: window,
                            bubbles: true, //是否冒泡
                            cancelable: true, //事件是否可以取消
                        });
                        let name = this.selFiles[0].key.split("/");
                        name = name[name.length - 1];
                        if (this.isPrivate) {
                            name = this.selFiles[0].info.name + ".eddx";
                        }
                        aLink.download = name;
                        aLink.href = URL.createObjectURL(blob);
                        aLink.dispatchEvent(event);
                    });
                }
            } else {
                let needUpdate = this.needPCUpdate("11.5.5", this.$t("tip"), this.$t("useSymbolTip"), this.$t("toUpgrade"), this.$t("cancelText"));
                if (needUpdate) return;
                const option = this.$edMessage.loading({
                    content: <string>this.$t("fileDownloading"),
                    duration: 0,
                });
                let proArr = [];
                for (let i = 0; i < this.selFiles.length; i++) {
                    proArr.push(
                        new Promise((response) => {
                            this.$store.dispatch("downloadFiles", this.selFiles[i]).then((res) => {
                                let name = this.selFiles[i].key.split("/");
                                name = name[name.length - 1];
                                if (this.isPrivate) {
                                    name = this.selFiles[i].info.name + ".eddx";
                                }
                                response([name, res.data]);
                            });
                        })
                    );
                }
                Promise.all(proArr).then((res) => {
                    let zip = new JSZip();
                    for (let i = 0; i < res.length; i++) {
                        zip.file(res[i][0], res[i][1]);
                    }
                    let name = "[" + this.$t("batch") + "]" + res[0][0].replace(".eddx", "") + this.$t("etc") + ".zip";
                    zip.generateAsync({
                        type: "blob",
                        mimeType: "application/octet-stream",
                        compression: "DEFLATE",
                        compressionOptions: {
                            level: 6,
                        },
                    })
                        .then((content) => {
                            saveAs(content, name);
                            if (!this.isPC) {
                                setTimeout(option as any, 0);
                            }
                        })
                        .catch(() => {
                            if (!this.isPC) {
                                setTimeout(option as any, 0);
                            }
                            this.$edMessage.warning(this.$t("networkError"));
                        });
                });
            }
        }
        downloadFolder() {
            let needUpdate = this.needPCUpdate("11.5.5", this.$t("tip"), this.$t("useSymbolTip"), this.$t("toUpgrade"), this.$t("cancelText"));
            if (needUpdate) return;
            if (this.isPC) {
                this.$edMessage.loading({
                    content: <string>this.$t("fileDownloading"),
                    duration: 0,
                });
            }
            let params = {
                id: this.userInfo.user_id,
                token: this.userInfo.token,
                path: this.selectFolder.prefix,
            };
            let downloadFile = (obj) => {
                let filePath = obj.key.replace(this.selectFolder.prefix, "");
                return new Promise((resolve, reject) => {
                    let ossParams = {
                        url: obj.key,
                        sign: obj.sign || obj.query,
                        exp: obj.exp,
                        responseType: "blob",
                    };
                    this.$edApi
                        .downloadOSSFile(ossParams)
                        .then((res) => {
                            let name = obj.key.split("/");
                            name = name[name.length - 1];
                            if (this.isPrivate) {
                                filePath = obj.prefix + obj.name + ".eddx";
                            }
                            resolve([filePath, res.data]);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                });
            };
            this.$edApi.getDownFolderAddress(params).then((signInfo) => {
                console.log(signInfo);
                let proArr = [];
                for (let i = 0; i < signInfo.data.length; i++) {
                    proArr.push(downloadFile(signInfo.data[i]));
                }
                Promise.all(proArr).then((data) => {
                    console.log(data);
                    let zip = new JSZip();
                    for (let i = 0; i < data.length; i++) {
                        zip.file(data[i][0], data[i][1]);
                    }
                    zip.generateAsync({
                        type: "blob",
                        mimeType: "application/octet-stream",
                        compression: "DEFLATE",
                        compressionOptions: {
                            level: 6,
                        },
                    })
                        .then((content) => {
                            saveAs(content, `${this.selectFolder.name}.zip`);
                        })
                        .catch(() => {
                            this.$edMessage.warning(this.$t("networkError"));
                        });
                });
            });
        }

        rename() {
            this.$track("cloudfile", "Right click menu", "rename file");
            this.renameValue = this.selFiles[0].name;
            this.renameShow = true;
            // setTimeout(() => {
            //     let dom = <HTMLInputElement> document.querySelector('.file-rename')
            //     dom.select()
            // })
        }

        checkFolderName(name, list) {
            let exit = 0,
                exitExpand = 0,
                exitFlag = true,
                numList = [];
            let p = new RegExp("(?=[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？%])", "g"),
                ruleone = new RegExp("\^" + name.replace(p, "\\") + "\\\(\\\d+\\\)$"),
                ruletwo = new RegExp("\^" + name.replace(p, "\\") + "\\\((\\\d*)");

            for (let v of list) {
                if (exitFlag && v.name == name) {
                    exit = 1;
                    exitFlag = false;
                }
                if (ruleone.test(v.name)) {
                    let tempNum = ~~v.name.match(ruletwo)[1];
                    if (tempNum > 0) {
                        numList.push(tempNum);
                        exitExpand = 1;
                    }
                }
            }

            if (exit == 0) {
                return name;
            } else {
                if (exitExpand != 1) {
                    return `${name}(1)`;
                } else {
                    numList = numList.sort((a, b) => {
                        return a - b;
                    });
                    var k;
                    for (var i = 0, len = numList.length; i < len; i++) {
                        if (i + 1 != numList[i]) {
                            k = i + 1;
                            break;
                        } else {
                            k = numList[len - 1] + 1;
                        }
                    }
                    return `${name}(${k})`;
                }
            }
        }

        renameFolder() {
            console.log("rename");
            if (!this.renameValue) {
                (<any>this).$edMessage.warning(this.$t("noEmpty"));
                return;
            }
            if (/[%#?&<^$/\\*<>.|:"]/.test(this.renameValue)) {
                (<any>this).$edMessage.warning(this.$t("invalidName"));
                return;
            }
            let hasFolder = false;
            this.folderList.forEach((f, i) => {
                if (f.name == this.renameValue) {
                    hasFolder = true;
                }
            });
            if (hasFolder) {
                (<any>this).$edMessage.warning(this.$t("existFolder"));
                this.folderRenameShow = null;
                return;
            }
            this.renaming = true;
            if (this.selectFolder.type == "created") {
                let item = {
                    name: this.renameValue,
                    prefix: this.path.length
                        ? this.host + "/" + this.path.join("/") + "/" + this.renameValue + "/"
                        : this.host + "/" + this.renameValue + "/",
                };
                // let hasFolder = false
                // this.folderList.forEach((f, i) => {
                //     if (f.name == this.renameValue && i != this.folderList.length - 1) {
                //         hasFolder = true
                //     }
                // })
                // if (hasFolder) {
                //     this.folderList.pop();
                //     (<any>this).$edMessage.success(this.$t("existFolder"))
                //     this.folderRenameShow = null
                // } else {
                let prefix = this.path.join("/");
                if (prefix) prefix = prefix + "/";
                this.$store
                    .dispatch("createFolder", { prefix: prefix + this.renameValue + "/" })
                    .then((res) => {
                        if (this.isPrivate) {
                            Object.assign(item, {
                                folder_id: res.data.data.id,
                                prefix: this.path.length ? this.path.join("/") + "/" + this.renameValue + "/" : this.renameValue + "/",
                            });
                        }
                        this.folderList.push(item);
                        delete this.selectFolder.type;
                        this.renaming = false;
                        this.selectFolder.name = this.renameValue;
                        // this.selectFolder.prefix = this.selectFolder.prefix.replace(/[^\/]*\/$/,this.renameValue+"/")
                        this.folderRenameShow = null;
                        if (this.rotate == 0) {
                            this.folderList = this.folderList.sort((a, b) => naturalsort(a.name, b.name));
                        } else {
                            this.folderList = this.folderList.sort((a, b) => naturalsort(b.name, a.name));
                        }
                        (<any>this).$edMessage.success(this.$t("createSucc"));
                        this.updateCache(null, this.folderList);
                    })
                    .catch((err) => {
                        console.log(err);
                        this.renaming = false;
                        if (err.data.msg == "The prefix format is invalid.") {
                            (<any>this).$edMessage.warning(this.$t("invalidName"));
                        }
                        if (err.data && err.data.msg == "data invalid") {
                            (<any>this).$edMessage.warning(this.$t("invalidName"));
                        }
                    });
                // }
                // }
            } else {
                this.$store
                    .dispatch("renameFolder", { folder: this.selectFolder, name: this.renameValue })
                    .then((res) => {
                        this.folderRenameShow = null;
                        this.renaming = false;
                        if (
                            res.data.msg == "folder contain different file type, could not delete" ||
                            res.data.msg == "folder contain different file type, could not copy"
                        ) {
                            (<any>this).$edMessage.warning(this.$t("cantDel"));
                            return;
                        }
                        this.selectFolder.name = this.renameValue;
                        this.selectFolder.prefix = this.selectFolder.prefix.replace(/[^\/]*\/$/, this.renameValue + "/");
                        if (this.rotate == 0) {
                            this.folderList = this.folderList.sort((a, b) => naturalsort(a.name, b.name));
                        } else {
                            this.folderList = this.folderList.sort((a, b) => naturalsort(b.name, a.name));
                        }
                        this.updateCache(null, this.folderList);
                    })
                    .catch((err) => {
                        this.renaming = false;
                        if (err.data.to && err.data.to[0] == "The to format is invalid.") {
                            (<any>this).$edMessage.warning(this.$t("invalidName"));
                        }
                        if (err.data && ["data invalid", "Server Error"].includes(err.data.msg || err.data.message)) {
                            (<any>this).$edMessage.warning(this.$t("invalidName"));
                        }
                    });
            }
        }
        renameFile() {
            let isSameName = false;
            this.renameValue = this.renameValue.trim();
            let fileName = checkFileName(this.renameValue);
            if (!fileName) {
                this.$edMessage.error(this.$t("renameFail"));
                return;
            }
            this.filesList.forEach((file) => {
                if (file.name == this.renameValue && this.renameValue != this.selFiles[0].name) {
                    isSameName = true;
                }
            });
            if (!this.renameValue) {
                (<any>this).$edMessage.warning(this.$t("noEmpty"));
                return;
            }
            if (isSameName) {
                (<any>this).$edMessage.warning(this.$t("sameName"));
                this.renameShow = null;
                return;
            }
            if (this.renameValue.match(/[\\|\/|\:|\*|\?|\"|\<|\>|\||\&|\%|\$|\.]/)) {
                (<any>this).$edMessage.warning(this.$t("renameFail"));
                return;
            }

            if (this.renameValue && this.renameValue != this.selFiles[0].name) {
                this.renaming = true;
                this.$store
                    .dispatch("rename", { files: this.selFiles[0], name: this.renameValue })
                    .then((res) => {
                        this.renaming = false;
                        this.selFiles[0].name = this.renameValue;
                        if (this.selFiles[0].info && this.selFiles[0].info.share_url) {
                            this.selFiles[0].info.share_url = "";
                        }
                        this.selFiles[0].key = this.selFiles[0].key.replace(/(.+\/)(.*)\.eddx$/, (a, b, c) => {
                            return b + this.renameValue + ".eddx";
                        });
                        if (this.orderName == "name") {
                            this.filesList = this.filesList.sort((a, b) => naturalsort(a.name, b.name));
                        }
                        this.renameShow = null;
                        this.updateCacheAfterRename(this.selFiles[0].info.id, this.renameValue);
                    })
                    .catch((err) => {
                        console.log(err);
                        this.renaming = false;
                        if (err.data && err.data.to && err.data.to[0] == "The to format is invalid.") {
                            (<any>this).$edMessage.warning(this.$t("renameFail"));
                        }
                        if (err.data && err.data.msg == "data invalid") {
                            (<any>this).$edMessage.warning(this.$t("renameFail"));
                        }
                    });
            } else {
                this.renameShow = null;
            }
        }
        reload() {
            this.host = this.userInfo.user_name + "/Personal";
            if (this.path) {
                if (this.path.length == 0) {
                    this.getFloder("", null, true);
                } else {
                    this.getFloder(this.path.join("/") + "/", null, true);
                }
            }
        }
        scrollAdding = false;
        tempCache = null;
        tempCacheIndex = -1;
        cloudCache = [
            // {
            //     path: '',
            //     offset: 0,
            //     total: 0,
            //     files: []
            //     folders: []
            // }
        ];
        fileNum = 30;
        saveToCache(path, files, folders) {
            let obj = {
                path,
                offset: this.fileNum,
                total: files.length,
                files,
                folders,
            };
            this.tempCache = obj;
            this.tempCacheIndex = this.cloudCache.length;
            let index = -1;
            for (let i = 0; i < this.cloudCache.length; i++) {
                if (this.cloudCache[i].path == path) {
                    index = i;
                    break;
                }
            }
            if (index != -1) {
                this.cloudCache.splice(index, 1, obj);
                this.tempCacheIndex = index;
            } else {
                this.cloudCache.push(obj);
            }
            console.log(this.cloudCache, index);
        }
        updateCache(files, folders, path = null) {
            if (path) {
                // 更新指定目录（仅在移动时使用）
                for (let i = 0; i < this.cloudCache.length; i++) {
                    if (this.cloudCache[i].path == path) {
                        files && (this.cloudCache[i].files = this.cloudCache[i].files.concat(JSON.parse(JSON.stringify(files))));
                        folders && (this.cloudCache[i].folders = this.cloudCache[i].folders.concat(JSON.parse(JSON.stringify(folders))));
                        return;
                    }
                }
            } else {
                // 更新当前目录
                if (this.tempCacheIndex != -1) {
                    files && (this.cloudCache[this.tempCacheIndex].files = JSON.parse(JSON.stringify(files)));
                    folders && (this.cloudCache[this.tempCacheIndex].folders = JSON.parse(JSON.stringify(folders)));
                }
            }
        }
        deleteCacheByPath(path) {
            // 删除指定目录缓存
            for (let i = 0; i < this.cloudCache.length; i++) {
                if (path == this.cloudCache[i].path) {
                    this.cloudCache.splice(i, 1);
                    break;
                }
            }
        }
        cleanCache() {
            // 删除全部缓存
            this.tempCache = null;
            this.tempCacheIndex = -1;
            this.cloudCache = [];
        }
        updateCacheAfterAddFile(file) {}
        updateCacheAfterRename(id, renameStr) {
            if (this.tempCacheIndex != -1) {
                let files = this.cloudCache[this.tempCacheIndex].files;
                for (let i = 0; i < files.length; i++) {
                    if (files[i].info.id == id) {
                        files[i].name = renameStr;
                        files[i].key = files[i].key.replace(/(.+\/)(.*)\.eddx$/, (a, b, c) => {
                            return b + renameStr + ".eddx";
                        });
                        files[i].info.obj = files[i].info.obj.replace(/(.+\/)(.*)\.eddx$/, (a, b, c) => {
                            return b + renameStr + ".eddx";
                        });
                        break;
                    }
                }
            }
        }
        updateCacheAfterDelFiles(filesID) {
            // 删除文件后更新对应缓存 *** 11.5.5版本后不适用，需刷新info.edit字段
            if (this.tempCacheIndex != -1) {
                let cache = this.cloudCache[this.tempCacheIndex].files;
                for (let i = cache.length - 1; i >= 0 && filesID.length != 0; i--) {
                    let index = filesID.indexOf(cache[i].info.id);
                    if (index != -1) {
                        filesID.splice(index, 1);
                        cache.splice(i, 1);
                    }
                }
            }
        }
        updateCacheAfterMove(from, to) {
            // 移动文件或文件夹时清除当前目录及目标目录缓存
            let list = [];
            for (let i = 0; i < this.cloudCache.length; i++) {
                if (this.cloudCache[i].path == to || this.cloudCache[i].path == from) {
                    list.push(i);
                }
            }
            list.sort((a, b) => b - a);
            for (let i = 0; i < list.length; i++) {
                this.cloudCache.splice(list[i], 1);
            }
        }
        readFromCache(path) {
            for (let i = 0; i < this.cloudCache.length; i++) {
                if (this.cloudCache[i].path == path) {
                    this.tempCache = this.cloudCache[i];
                    this.tempCacheIndex = i;
                    return this.cloudCache[i];
                }
            }
            return false;
        }
        loadMoreFromCache(force = false) {
            let cache = null;
            if (this.tempCache && !force) {
                cache = this.tempCache;
            } else {
                cache = this.readFromCache(this.nowPrefix);
            }

            let offset = cache.offset;
            let tempList = JSON.parse(JSON.stringify(cache.files));
            let list = tempList.splice(offset, this.fileNum);
            offset = offset + this.fileNum > cache.total ? cache.total : offset + this.fileNum;
            this.cloudCache[this.tempCacheIndex].offset = offset;
            this.tempCache.offset = offset;
            this.filesList = this.filesList.concat(list);
            setTimeout(() => {
                this.scrollAdding = false;
            }, 200);
        }
        scrollToAdd() {
            let con = <HTMLElement>this.$refs.filesScroll;
            if (this.scrollAdding) return;
            var scrollTop = con.scrollTop;
            if (con.scrollHeight - (scrollTop + con.offsetHeight) < 30) {
                if (this.tempCache && this.tempCache.total == this.tempCache.offset) return;
                this.scrollAdding = true;
                this.loadMoreFromCache();
            }
        }
        scrollFitFlag = false;
        scrollFitTimer = 0;
        scrollFit() {
            console.log(1111);
            // 个别情况下存在不出现滚动条场景
            if (this.scrollFitFlag) return;
            this.scrollFitFlag = true;
            this.scrollFitTimer = setInterval(() => {
                this.$nextTick(() => {
                    let con = <HTMLElement>this.$refs.filesScroll;
                    if (!con) {
                        this.scrollFitFlag = false;
                        clearInterval(this.scrollFitTimer);
                        return;
                    }
                    let cache = this.readFromCache(this.nowPrefix);
                    if (con.offsetHeight == con.scrollHeight && cache && cache.files.length > this.filesList.length) {
                        this.loadMoreFromCache();
                    } else {
                        this.scrollFitFlag = false;
                        clearInterval(this.scrollFitTimer);
                    }
                });
            }, 300);
        }
        getFloderIndex = 0;
        getFloder(prefix, toSelectFilesId: any = null, force = false, callback = null) {
            console.log(this.folderList, prefix);
            let index = ++this.getFloderIndex;
            if (!this.params.islogin) {
                this.isGetFloder = false;
                this.$store.commit("setState", { data: false, type: "showLoading" });
                return;
            }
            this.nowPrefix = prefix;
            this.$store.commit("setState", { type: "currentPath", data: prefix });
            if (this.isPrivate) {
                for (let i = 0; i < this.folderList.length; i++) {
                    if (this.folderList[i].prefix == prefix) {
                        this.nowPrefixId = this.folderList[i].folder_id;
                        this.$store.commit("setState", {
                            type: "currentPathId",
                            data: this.nowPrefixId,
                        });
                        break;
                    }
                }
            }
            this.isGetFloder = true;
            this.$store.commit("setState", { data: true, type: "showLoading" });
            this.tempCache = null;
            this.tempCacheIndex = -1;
            setTimeout(() => {
                if (index != this.getFloderIndex) {
                    console.log("break get");
                    return;
                }
                let cache = this.readFromCache(prefix);
                if (cache && !force) {
                    console.log("use cache");
                    this.isGetFloder = false;
                    this.folderList = cache.folders;
                    let tempList = JSON.parse(JSON.stringify(cache.files));
                    this.filesList = tempList.splice(0, cache.offset);
                    // this.setOrder(this.orderName);
                    if (toSelectFilesId) {
                        let selIndexs = [];
                        this.filesList.forEach((item, index) => {
                            if (item.info && item.info.id && toSelectFilesId.includes(item.info.id)) {
                                selIndexs.push(index);
                            }
                        });
                        this.selectFilesIndex = selIndexs;
                    }
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    this.scrollFit();
                    callback && callback();
                } else {
                    console.log("use cloud");
                    this.$store
                        .dispatch("getFloder", { prefix })
                        .then((res) => {
                            if (!this.userInfo.islogin) {
                                // fix 桌面加载过程中退出，状态共存
                                return;
                            }
                            this.isGetFloder = false;
                            this.loadFailed = false;
                            // console.log("userIndo==-*(@*#()"+JSON.stringify(this.$store.state.userInfo));
                            let folderList = res.data.data.folders || [];
                            let filesList = res.data.data.files || [];
                            folderList.map((item) => {
                                let list = item.prefix.split("/");
                                item.name = list[list.length - 2];
                            });
                            if (this.isPrivate) {
                                filesList = filesList.map((item) => {
                                    item.name = item.info.name;
                                    return item;
                                });
                            } else {
                                filesList = filesList.filter((item) => {
                                    if (item.key.match(/.+eddx$/)) {
                                        let list = item.key.split("/");
                                        let name = list[list.length - 1];
                                        name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1];
                                        item.name = name;
                                        return true;
                                    }
                                    return false;
                                });
                            }
                            filesList = this.sortByOrder(this.orderName, filesList);
                            this.saveToCache(prefix, JSON.parse(JSON.stringify(filesList)), JSON.parse(JSON.stringify(folderList)));
                            this.folderList = folderList;
                            this.filesList = filesList.splice(0, this.fileNum);

                            // this.setOrder(this.orderName);
                            if (toSelectFilesId) {
                                let selIndexs = [];
                                this.filesList.forEach((item, index) => {
                                    if (item.info && item.info.id && toSelectFilesId.includes(item.info.id)) {
                                        selIndexs.push(index);
                                    }
                                });
                                this.selectFilesIndex = selIndexs;
                            }
                            this.scrollFit();
                            callback && callback();
                            this.$store.commit("setState", { data: false, type: "showLoading" });
                        })
                        .catch((err) => {
                            this.isGetFloder = false;
                            this.loadFailed = true;
                            console.log("userIndo==-*(@*#()" + JSON.stringify(this.$store.state.userInfo));
                            this.$store.commit("setState", { data: false, type: "showLoading" });
                        });
                }
            }, 0);
        }

        refreshCache(path) {
            console.log("refresh cache", path);
            if (!this.params.islogin) {
                return;
            }
            return new Promise((a, b) => {
                this.$store
                    .dispatch("getFloder", { prefix: path })
                    .then((res) => {
                        let folderList = res.data.data.folders || [];
                        let filesList = res.data.data.files || [];
                        folderList.map((item) => {
                            let list = item.prefix.split("/");
                            item.name = list[list.length - 2];
                        });
                        if (this.isPrivate) {
                            filesList = filesList.map((item) => {
                                item.name = item.info.name;
                                return item;
                            });
                        } else {
                            filesList = filesList.filter((item) => {
                                if (item.key.match(/.+eddx$/)) {
                                    let list = item.key.split("/");
                                    let name = list[list.length - 1];
                                    name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1];
                                    item.name = name;
                                    return true;
                                }
                                return false;
                            });
                        }
                        filesList = this.sortByOrder(this.orderName, filesList);
                        this.saveToCache(path, JSON.parse(JSON.stringify(filesList)), JSON.parse(JSON.stringify(folderList)));
                    })
                    .catch((err) => {});
            });
        }

        // selectFile (files, index) {
        //     this.selectFolderIndex = null
        //     this.selectFiles = files
        //     if(false && this.ctrldown){
        //         let flag = false;
        //         for(let i = 0; i < this.selectFilesIndex.length; i++){
        //             if(this.selectFilesIndex[i] == index){
        //                 this.selectFilesIndex.splice(i, 1);
        //                 flag = true;
        //                 break
        //             }
        //         }
        //         !flag && this.selectFilesIndex.push(index);
        //     }else{
        //         this.selectFilesIndex = [index];
        //     }
        // }

        delFiles() {
            if (this.selectFilesIndex.length == 0) return;
            this.$track("cloudfile", "Right click menu", "delete");
            if (this.isOperating) return;
            let promiseList = [];
            let delSuccess = [];
            let failList = [];
            let ids = [];
            let file_keys = [];
            for (let i = 0; i < this.selectFilesIndex.length; i++) {
                if (this.activeList[this.selectFilesIndex[i]].info && this.activeList[this.selectFilesIndex[i]].info.id != undefined) {
                    ids.push(this.activeList[this.selectFilesIndex[i]].info.id);
                    file_keys.push(this.activeList[this.selectFilesIndex[i]].info.file_key);
                    delSuccess.push(this.selectFilesIndex[i]);
                } else {
                    failList.push(this.activeList[this.selectFilesIndex[i]].name);
                }
            }
            if (failList.length) {
                let names = failList.join(", ");
                this.$edMessage.warning({
                    content: names + " " + this.$t("errFile"),
                    duration: 6,
                });
            }
            if (!ids.length) {
                return;
            }
            this.$store.commit("setState", { data: true, type: "showLoading" });
            this.isOperating = true;
            new Promise((res, rej) => {
                this.$store
                    .dispatch("delFilesBatch", {
                        ids,
                        file_keys,
                        platform: this.$store.state.publicStore.runPlatform,
                    })
                    .then((res) => {
                        this.isOperating = false;
                        if (res.data.msg == "file num over limit") {
                            (<any>this).$edMessage.warning(this.$t("deleteLimit"));
                            this.$checkAuth({
                                type: "addRecycle",
                                buyTrigger: "recycleNumberPop",
                                pcParams: { newUpgrade: 1, upgrade: 3 },
                            });
                        } else if (res.data.status == "success") {
                            (<any>this).$edMessage.success(this.$t("delSuccess"));
                            this.activeList = this.activeList.filter((v, k) => !delSuccess.includes(k));
                        }
                        this.$store.commit("setState", { data: false, type: "showLoading" });
                        this.clearFile();

                        this.deleteCacheByPath(this.nowPrefix); // 新建文件在编辑页完成，所以清除当前目录缓存
                        this.getFloder(this.nowPrefix); // 刷新云文档目录
                        // this.updateCacheAfterDelFiles(ids);
                        // this.$nextTick(() => {
                        //     let con = <HTMLElement>this.$refs.filesScroll;
                        //     console.log(con.offsetHeight ,con.scrollHeight)
                        //     if(con.offsetHeight == con.scrollHeight) {
                        //         this.loadMoreFromCache(true);
                        //     }
                        // })
                    })
                    .catch((err) => {
                        this.isOperating = false;
                        this.$store.commit("setState", { data: false, type: "showLoading" });
                    });
            });
            // Promise.all(promiseList).then(e => {

            //     this.selectFilesIndex = [];
            // }).catch(e => {
            //     this.filesList = this.filesList.filter((v, k) => !delSuccess.includes(k));
            //     this.selectFilesIndex = [];
            // })
        }

        delFolder() {
            this.$track("files", "delete folder");
            if (this.isOperating) return;
            this.isOperating = true;
            this.$store.commit("setState", { data: true, type: "showLoading" });
            this.$store
                .dispatch("delFolder", {
                    folder: this.selectFolder,
                    platform: this.isPC ? "pc" : "web",
                })
                .then((res) => {
                    this.isOperating = false;
                    if (res.data.status == "success") {
                        this.folderList.splice(this.selectFolderIndex, 1);
                        (<any>this).$edMessage.success(this.$t("delSuccess"));
                        this.updateCache(null, this.folderList);
                    } else {
                        if (res.data.msg == "folder contain different file type, could not delete") {
                            (<any>this).$edMessage.warning(this.$t("cantDel"));
                        }
                        if (res.data.msg == "file num over limit") {
                            (<any>this).$edMessage.warning(this.$t("deleteLimit"));
                            this.$checkAuth({
                                type: "addRecycle",
                                buyTrigger: "recycleNumberPop",
                                pcParams: { newUpgrade: 1, upgrade: 3 },
                            });
                        }
                    }
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    this.selectFolderIndex = null;
                })
                .catch((err) => {
                    this.isOperating = false;
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                });
        }

        // share (item) {
        //     if(!item){
        //         item = this.selFiles[0]
        //     }
        //     if (item.info && item.info.share_url) {
        //         let shareHtml = `<iframe frameborder="no" border="0" marginwidth="0" marginheight="0" width=800 height=800 src="${item.info.frame_url}"></iframe>'`
        //         this.$store.commit('setState', {type: 'shareLink', data: item.info.share_url})
        //         this.$store.commit('setState', {type: 'shareHTML', data: shareHtml})
        //         this.$store.commit('setState', {type: 'shareData', data: {
        //             title: item.name,
        //             imgUrl: this.onlineFilesImg(item.info.img,item.info.down_exp,item.info.img_down_sign, item.lastModified)
        //         }})
        //         this.$store.commit('setState', {type: 'shareState', data: true})
        //     } else {
        //         this.selectFiles = item
        //         this.shareTipState = true
        //     }
        // }

        toShare() {
            let ts: any = this;
            // localStorage.setItem('max_action', 'share')
            let item = this.selFiles[0];

            if (this.isPC) {
                this.$edMessage.loading({
                    content: <string>this.$t("fileDownloading"),
                    duration: 0,
                });
                let userP = this.$store.getters.apiParam;
                let filePath = item.key.match(/[^\/]+\/[^\/]+\/(.+)/) && item.key.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
                let params = Object.assign({ obj: filePath }, userP);
                this.$edApi
                    .getDownFileAddress(params)
                    .then((signInfo) => {
                        let obj = item.key;
                        //中文站用的oss，英文站用的aws，通过getSignature得到的数据不一样
                        let paramForPc;
                        if (this.internal) {
                            let { sign, exp } = signInfo.data;
                            sign = encodeURIComponent(sign);
                            paramForPc = {
                                fileName: item.name,
                                sign,
                                exp,
                                obj,
                                type: "share",
                                accessid: this.OSSAccessKeyId,
                            };
                        } else {
                            let { path, query } = signInfo.data;
                            paramForPc = {
                                fileName: item.name,
                                path,
                                query,
                                type: "share",
                                accessid: this.OSSAccessKeyId,
                            };
                        }
                        (<any>window).$qt.jsCallCloudFileOperate(JSON.stringify(paramForPc));
                    })
                    .catch(() => {
                        this.$edMessage.warning(this.$t("networkError"));
                    });
            } else {
                let newTab;
                if (this.openInTabs) {
                    location.href =
                        window.location.origin + (<any>this.$router).options.base + "app.html?" + ts.$zipFileName("obj=" + item.key) + "#share";
                    return;
                }
                let fileObj = this.isAd ? "obj=" + item.key + `&from=ad` : "obj=" + item.key;
                let fileName = this.isPrivate ? "&name=" + item.name : "";
                if (item.info && item.info.edit === false) {
                    // 进入仅预览模式
                    fileName += "&preview=1";
                }
                newTab = window.open(
                    window.location.origin + (<any>this.$router).options.base + "app.html?" + ts.$zipFileName(fileObj + fileName) + "#share",
                    item.key
                );

                this.$store.commit("setAppState", "share");
                let timer = setInterval(() => {
                    try {
                        newTab.name;
                        if (!newTab.parent) {
                            this.$store.commit("setAppState", "");
                            clearInterval(timer);
                        }
                        if (!newTab.location.hash) {
                            this.$store.commit("setAppState", "");
                            clearInterval(timer);
                        }
                    } finally {
                    }
                }, 500);
                // this.$store.state.winobj[item.key] = newTab
                let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
                if (!openTabs.includes(item.key)) {
                    openTabs.push(item.key);
                }
                localStorage.setItem("openTabs", JSON.stringify(openTabs));
            }
        }

        // top menu
        showTopMenu = false;
        topMenuTop = 0;
        topMenuLeft = 0;
        showTopContext(e) {
            if (this.$isBiggerVersion("11.5.5") || !this.isPC) {
                e.preventDefault();
                this.closeFileMenu();
                this.clearFile();
                let menu = document.getElementById("topMenu");
                let container = this.$refs.rootDom as HTMLElement;
                let baseLeft = container.getBoundingClientRect()["x"],
                    baseTop = container.getBoundingClientRect()["y"];
                this.showTopMenu = true;
                this.topMenuLeft = e.pageX;
                this.topMenuTop = e.pageY;
                this.$nextTick(() => {
                    let width = menu.offsetWidth,
                        height = menu.offsetHeight;
                    if (e.pageY - baseTop + height > container.clientHeight) {
                        this.topMenuTop -= height;
                    }
                    if (e.pageX - baseLeft + width > container.clientWidth) {
                        this.topMenuLeft -= width;
                    }
                });
            }
        }
        topMenuClick(type: string) {
            switch (type) {
                case "refresh":
                    // if(this.isPC) {
                    //     (<any>window).$qt.jsCallReloadIgnoreCache && (<any>window).$qt.jsCallReloadIgnoreCache();
                    // } else {
                    this.folderList = [];
                    this.filesList = [];
                    this.searchList = [];
                    this.searchMode = false;
                    this.getFloder(this.nowPrefix, null, true);
                    (this.$refs.filesScroll as HTMLElement).scrollTop = 0;
                    // }
                    break;
                case "newFolder":
                    this.toCreateFolder();
                    break;
                case "newFile":
                    this.toCreateFile();
                    break;
                case "import":
                    this.showImportModal();
                    break;
            }
            this.closeTopMenu();
        }
        setSaveInputName(name) {
            this.saveInputName = name;
        }

        // drag select
        get preventDragSelect() {
            return this.pcSaveInput || this.mouseEventType == 1;
        }
        dragMouseDown() {
            this.clearFile(1);
        }
        dragMouseMove() {}
        dragMouseUp(isMove, isClickFile) {
            if (!isMove) {
                if (this.mulSelectMode && isClickFile) {
                } else {
                    this.clearFile();
                    this.clearFolder();
                }
            } else this.selectFilesIndex.length > 0 && (this.mulSelectMode = true);
        }
        @Watch("vip")
        vipChange(nv, ov) {
            if (nv != ov) {
                this.cleanCache();
                this.folderList = [];
                this.filesList = [];
                this.searchList = [];
                this.searchMode = false;
                this.getFloder(this.nowPrefix, null, true);
            }
        }
    }
</script>

<i18n>
{
  "zh": {
    "switchView": "切换视图",
    "addNew": "新建",
    "allFiles": "所有文件",
    "personal": "个人云",
    "search": "搜索文件",
    "name": "文件名",
    "time": "时间",
    "size": "大小",
    "customTag": "标签",
    "folder": "文件夹",
    "eddxFile": "文件",
    "grid": "网格视图",
    "list": "列表视图",
    "tag": "标签",
    "open": "打开",
    "rename": "重命名",
    "download": "下载",
    "del": "删除",
    "copy": "复制",
    "cut": "剪切",
    "moveTo": "移动到",
    "copyTo": "复制到",
    "renameFile": "重命名文件",
    "renameFolder": "重命名文件夹",
    "confirm": "确定",
    "cancel": "取消",
    "tip": "Edraw 提醒",
    "share": "分享",
    "shareTip": "该文件还未分享，是否立即分享？",
    "invalidName": "名字不能包含特殊字符(& % $ \\ \/ \" : * ? < > | . 😊等)",
    "sameName": "该名称文件已存在",
    "noEmpty": "名字不能为空！",
    "delSuccess": "删除成功",
    "fileOverLimit": "文件超出限制, 请先清理些文件",
    "spaceOverLimit": "云空间超出限制，请先清理些文件",
    "createCopy": "创建副本",
    "createCopySucc": "创建副本成功",
    "copySucc": "复制成功，请按 Ctrl + V 粘贴",
    "cutSucc": "剪切成功",
    "pasteSucc": "粘贴成功",
    "pasteFail": "粘贴失败，请重试",
    "createFolder": "新建文件夹",
    "inputFileTip": "请输入文件名",
    "inputFolderTip": "请输入文件夹名",
    "createSucc": "创建成功",
    "existFolder": "文件夹已存在",
    "notTem": "此文件夹为空",
    "cantDel": "该文件夹存在其他格式文件(MindMaster文件）， 不能直接操作",
    "path": "路径",
    "notFind": "没有找到相关文件",
    "moveto": "已移动到 ",
    "create": "正在创建文件中，请稍后再试",
    "openTips": "正在打开文件，请稍后再试",
    "deleteLimit": "非会员回收站只能保存5个文件",
    "usedStorage": "已用空间：",
    "renameFail": "重命名失败，名字不能包含特殊字符(& % $ \\ \/ \" : * ? < > | . 😊等)",
    "oneSamePreTip": "当前文件夹已包含一个名为",
    "oneSameAffTip": "的文件",
    "mulSamePreTip": "当前文件夹包含",
    "mulSameAffTip": "个同名文件",
    "replaceFile": "替换",
    "skipFile": "跳过",
    "keepAllFile": "保留全部",
    "samePathTitle": "替换或跳过文件",
    "batch": "批量下载",
    "etc": "等",
    "newFile": "未命名文件",
    "moveSucc": "文件已移动到 ",
    "copySuccTo": "文件已复制到 ",
    "moveDirSucc": "文件夹已移动到 ",
    "copyDirSucc": "文件夹已复制到 ",
    "spaceNotEnough": "个人云空间不足",
    "copyFail": "复制失败",
    "moveFail": "移动失败",
    "move": "移动",
    "fileDownloading": "下载中...",
    "reloadPre": "网络似乎有些问题，",
    "reload": "重新加载",
    "errFile": "文件信息错误，请尝试修改文件后重试",
    "lockedFile": "文件已加密，请解密后再分享文件",
    "set": "设为",
    "star": "星标",
    "none": "无",
    "waitdone": "未完成",
    "done": "已完成",
    "waitchange": "需修改",
    "custom": "自定义",
    "customTips": "自定义标签",
    "addCustomTemplate": "添加到\"个人模板\"",
    "errorFile": "未选中文件或文件信息错误",
    "addTemplateSucc": "添加模板成功",
    "cancelText": "取消",
    "useSymbolTip": "当前版本不支持使用此功能，升级更新至v11.5.5以上版本即可立即使用",
    "toUpgrade": "去升级",
    "refresh": "刷新",
    "createFile": "新建空白文件",
    "import": "导入",
    "importFile": "导入文件",
    "networkError": "网络错误，请重试！"
  },
  "en": {
    "switchView": "Switch View",
    "addNew": "New",
    "allFiles": "All Files",
    "personal": "Personal",
    "search": "Search File",
    "name": "Name",
    "time": "Time",
    "size": "Size",
    "customTag": "Custom Tag",
    "folder": "Folder",
    "eddxFile": "File",
    "grid": "Grid View",
    "list": "List View",
    "tag": "Tag",
    "open": "Open",
    "rename": "Rename",
    "download": "Download",
    "del": "Delete",
    "copy": "Copy",
    "cut": "Cut",
    "moveTo": "Move to",
    "copyTo": "Copy to",
    "renameFile": "Rename File",
    "renameFolder": "Rename Folder",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "tip": "Edraw tips",
    "share": "Share",
    "shareTip": "This file has not been shared，would you like to share it？",
    "invalidName": "Invalid Name.check if the name contains special character, such as & % $ \\ \/ \" : * ? < > | . 😊, etc.",
    "sameName": "A file with the same name has already existed.",
    "noEmpty": "Name cannot be empty.",
    "delSuccess": "Delete successfully",
    "fileOverLimit": "Edraw cloud file amount reach maxium, please delete files or clear your recycle bin.",
    "spaceOverLimit": "Cloud space not enough, please delete files or clear your recycle bin.",
    "createCopy": "Create copy",
    "createCopySucc": "Create copy successfully",
    "copySucc": "Copy successfully",
    "cutSucc": "Cut successfully",
    "pasteSucc": "Paste successfully",
    "pasteFail": "Paste failed, please try again later.",
    "createFolder": "Create folder",
    "inputFileTip": "Please type in file name",
    "inputFolderTip": "Please type in folder name",
    "createSucc": "Create successfully ",
    "existFolder": "A folder with the same name has already existed.",
    "notTem": "This folder is empty.",
    "cantDel": "This folder includes other file formats (e.g. *.emmx), so you cannot operate it.",
    "path": "Path",
    "notFind": "No related files found",
    "moveto": "Moved to ",
    "create": "Creating file, please try again later.",
    "openTips": "Opening file, please try again later.",
    "deleteLimit": "The recycle bin can only keep 5 files for non-members.",
    "usedStorage": "Used Space: ",
    "renameFail": "Rename failed, check if the name contains special character, such as & % $ \\ \/ \" : * ? < > | . 😊, etc.",
    "oneSamePreTip": "This folder already includes ",
    "oneSameAffTip": "file",
    "mulSamePreTip": "This folder includes",
    "mulSameAffTip": "files with same name",
    "replaceFile": "Replace ",
    "skipFile": "Skip",
    "keepAllFile": "Keep All",
    "samePathTitle": "Replace or Skip",
    "batch": "Batch Download",
    "etc": "etc",
    "newFile": "Unnamed File",
    "moveSucc": "File successfully moved to ",
    "copySuccTo": "File successfully copied to ",
    "moveDirSucc": "Folder successfully moved to ",
    "copyDirSucc": "Folder copied to ",
    "copyFail": "Failed to Copy",
    "spaceNotEnough": "Insufficient personal cloud space",
    "moveFail": "Failed to Move",
    "move": "Move",
    "fileDownloading": "Downloading...",
    "reloadPre": "Network error",
    "reload": "click to reload",
    "errFile": "files info error, please modify the files and retry",
    "lockedFile": "The file is encrypted, please decrypt it before sharing",
    "set": "Add ",
    "star": "star",
    "none": "No",
    "waitdone": "In Process",
    "done": "Completed",
    "waitchange": "Need to be modified",
    "custom": "Customize",
    "customTips": "Custom label",
    "addCustomTemplate": "Add it to \"Personal Templates\"",
    "errorFile": "errorfile",
    "addTemplateSucc": "Add template success",
    "cancelText": "Cancel",
    "useSymbolTip": "The current version does not support this function. Please update to V11.5.5 or later versions to use it.",
    "toUpgrade": "Update Now",
    "refresh": "Refresh",
    "createFile": "Create blank drawing",
    "import": "Import",
    "importFile": "Import file",
    "networkError": "Network error, please try again!"
  },
  "fr": {
    "switchView": "Changer de vue",
    "addNew": "Nouveau",
    "allFiles": "Tous les fichiers",
    "personal": "Cloud personnel",
    "search": "Rechercher des fichiers",
    "name": "Nom",
    "time": "Temps",
    "size": "Taille",
    "customTag": "Étiquette personnalisée",
    "folder": "Dossier",
    "eddxFile": "Fichier",
    "grid": "Vue grille",
    "list": "Vue liste",
    "tag": "Étiquette",
    "open": "Allumez",
    "rename": "Renommer",
    "download": "Télécharger",
    "del": "Effacer",
    "copy": "Copier",
    "cut": "Couper",
    "moveTo": "Déplacer vers",
    "copyTo": "Copier à",
    "renameFile": "Renommer le fichier",
    "renameFolder": "Renommer le dossier",
    "confirm": "OK",
    "cancel": "Annuler",
    "tip": "Rappel Edraw",
    "share": "Partagez",
    "shareTip": "Le fichier n'a pas encore été partagé. Sera-t-il partagé immédiatement?",
    "invalidName": "Nom illégal",
    "sameName": "Le fichier de noms existe déjà",
    "noEmpty": "Le nom ne peut pas être vide!",
    "delSuccess": "Supprimé avec succès",
    "fileOverLimit": "Le fichier dépasse la limite, veuillez d'abord nettoyer certains fichiers",
    "spaceOverLimit": "L'espace cloud dépasse la limite, veuillez d'abord nettoyer certains fichiers",
    "createCopy": "Créer une copie",
    "createCopySucc": "Création réussie d'une copie",
    "copySucc": "Copie réussie",
    "cutSucc": "Couper avec succès",
    "pasteSucc": "Collage réussi",
    "pasteFail": "Échec du collage, veuillez réessayer",
    "createFolder": "Nouveau dossier",
    "inputFileTip": "Veuillez saisir un nom de fichier",
    "inputFolderTip": "Veuillez saisir un nom de dossier",
    "createSucc": "Créé avec succès",
    "existFolder": "Le dossier existe déjà",
    "notTem": "Ce dossier est vide",
    "cantDel": "Il existe d'autres fichiers de format (fichiers MindMaster) dans ce dossier et ne peuvent pas être supprimés directement",
    "path": "Chemin",
    "notFind": "Aucun document connexe trouvé",
    "moveto": "Déplacé vers",
    "create": "Création du fichier, veuillez réessayer plus tard",
    "openTips": "Ouverture du fichier, veuillez réessayer plus tard",
    "deleteLimit": "La corbeille non membre ne peut enregistrer que 5 fichiers",
    "usedStorage": "Espace utilisé:",
    "renameFail": "Échec du changement de nom, le nom ne peut pas contenir de caractères spéciaux (&% $ 😊 etc.)",
    "oneSamePreTip": "Le dossier actuel contient déjà un fichier",
    "oneSameAffTip": "nommé",
    "mulSamePreTip": "Le dossier actuel contient",
    "mulSameAffTip": "fichiers du même nom",
    "replaceFile": "Remplacez ces fichiers",
    "skipFile": "Ignorer ces fichiers",
    "keepAllFile": "Conserver tous les fichiers",
    "samePathTitle": "Remplacez ou Ignorer ces fichiers",
    "batch": "Téléchargement en masse",
    "etc": "etc.",
    "newFile": "Fichier sans nom",
    "moveSucc": "Déplacement avec Succès ",
    "copySuccTo": "Le fichier a été copié ",
    "moveDirSucc": "Dossier avec Succès ",
    "copyDirSucc": "Le dossier a été copié ",
    "spaceNotEnough": "Manque de place pour les nuages personnels",
    "copyFail": "Échec de réplication",
    "moveFail": "Échec du déplacement",
    "move": "Déplacer",
    "fileDownloading": "Téléchargement en cours...",
    "reloadPre": "Il semble y avoir des problèmes avec le réseau,",
    "reload": "Recharger",
    "errFile": "Erreur d'information sur le fichier, veuillez essayer de modifier le fichier et réessayer",
    "lockedFile": "Le fichier est chiffré, veuillez le déchiffrer avant de le partager",
    "set": "Mise en place",
    "star": "étoile",
    "none": "Rien",
    "waitdone": "Inachevé",
    "done": "Complété",
    "waitchange": "Besoin d'être modifié",
    "custom": "Personnalisé",
    "customTips": "Étiquette personnalisée",
    "addCustomTemplate": "Ajoutez-le à \"Modèles personnels\"",
    "errorFile": "Fichier d'erreurs",
    "addTemplateSucc": "Ajouter un modèle avec succès",
    "cancelText": "Annuler",
    "useSymbolTip": "La version actuelle ne prend pas en charge cette fonction. Veuillez mettre à jour la version V11.5.5 ou une version ultérieure pour l'utiliser.",
    "toUpgrade": "Mettez à jour",
    "refresh": "Rafraîchir",
    "createFile": "Créer un dessin vierge",
    "import": "Importer",
    "importFile": "Importer un fichier",
    "networkError": "Erreur réseau, veuillez réessayer !"
  },
  "de": {
    "switchView": "Ansicht wechseln",
    "addNew": "Neu erstellen",
    "allFiles": "Alle Dateien",
    "personal": "Persönlicher Cloud",
    "search": "Suchen",
    "name": "Name",
    "time": "Datum",
    "size": "Größe",
    "customTag": "Benutzerdefiniertes Etikett",
    "folder": "Ordner",
    "eddxFile": "Datei",
    "grid": "Gitternetz- Ansicht",
    "list": "Listenansicht",
    "tag": "Tag",
    "open": "Öffnen",
    "rename": "Umbenennen",
    "download": "Herunterladen",
    "del": "Löschen",
    "copy": "Kopieren",
    "cut": "Ausschneiden",
    "moveTo": "Verschieben nach ",
    "copyTo": "Kopie an",
    "renameFile": "Datei umbenennen",
    "renameFolder": "Ordner umbenennen",
    "confirm": "Bestätigen",
    "cancel": "Abbrechen",
    "tip": "Edraw Tipps",
    "share": "Teilen",
    "shareTip": "Diese Datei wurde nicht freigegeben. Möchten Sie sie freigeben?",
    "invalidName": "Ungültiger name",
    "sameName": "Eine gleichnamige Datei existiert bereits",
    "noEmpty": "Name darf nicht leer sein!",
    "delSuccess": "Erfolgreich gelöscht",
    "fileOverLimit": "Die Anzahl der Edraw-Cloud-Dateien überschreitet das Maximum. Bitte löschen Sie die Dateien oder leeren Sie den Papierkorb",
    "spaceOverLimit": "Cloud-Speicherplatz nicht ausreichend, bitte löschen Sie Dateien oder leeren Sie Ihren Papierkorb",
    "createCopy": "Kopie erstellen",
    "createCopySucc": "Erstellen der Kopie erfolgreich",
    "copySucc": "Kopie erfolgreich",
    "cutSucc": "Ausschneiden erfolgreich",
    "pasteSucc": "Einfügen erfolgreich",
    "pasteFail": "Einfügen fehlgeschlagen, versuchen Sie es später erneut",
    "createFolder": "Neuer Ordner ",
    "inputFileTip": "Bitte Dateinamen einfügen",
    "inputFolderTip": "Bitte Ordnernamen einfügen",
    "createSucc": "Erfolgreich erstellt",
    "existFolder": "Ein gleichnamiger Ordner ist bereits vorhanden",
    "notTem": "Dieser Ordner ist leer",
    "cantDel": "Dieser Ordner enthält andere Dateiformate (z. B. * .emmx), sodass Sie ihn nicht löschen können.",
    "path": "Pfad",
    "notFind": "Keine verwandten Dateien gefunden",
    "moveto": "Umgezogen nach",
    "create": "Datei wird erstellt, bitte später erneut versuchen",
    "openTips": "Datei wird geöffnet, versuchen Sie es später erneut",
    "deleteLimit": "Der Papierkorb kann nur 5 Dateien für Nichtmitglieder aufbewahren",
    "usedStorage": "Belegter Speicherplatz:",
    "renameFail": "Umbenennen fehlgeschlagen. Überprüfen Sie, ob der Name Sonderzeichen wie &% $ $ usw. enthält",
    "oneSamePreTip": "Der aktuelle Ordner enthält bereits ",
    "oneSameAffTip": "eine Datei mit dem Namen von ",
    "mulSamePreTip": "Der aktuelle Ordner enthält",
    "mulSameAffTip": "Datei mit demselben Name",
    "replaceFile": "Diese Dateien ersetzen",
    "skipFile": "Diese Dateien überspringen",
    "keepAllFile": "Alle Dateien speichern",
    "samePathTitle": "Dateien ersetzen oder überspringen",
    "batch": "Batch-Download",
    "etc": "usw.",
    "newFile": "Unbenannte Datei",
    "moveSucc": "Erfolgreich umgezogen",
    "copySuccTo": "Datei kopiert in ",
    "moveDirSucc": "Ordner auf",
    "copyDirSucc": "Ordner kopiert in ",
    "spaceNotEnough": "Unzureichender persönlicher Cloud-Raum",
    "copyFail": "Kopieren fehlgeschlagen",
    "moveFail": "Umzug gescheitert",
    "move": "Umziehen",
    "fileDownloading": "Herunterladen...",
    "reloadPre": "Es gibt Fehler beim Netzwerk",
    "reload": "Erneut laden",
    "errFile": "Fehler bei der Dateiinformation. Versuchen Sie es erneut nach der Korrektur. ",
    "lockedFile": "Die Datei ist verschlüsselt. Bitte entschlüsseln Sie sie vor dem Teilen.",
    "set": "Einstellen",
    "star": "Sternen",
    "none": "Nichts",
    "waitdone": "Unfertigt",
    "done": "Gefertigt",
    "waitchange": "Bearbeitbar",
    "custom": "Benutzerdefiniert",
    "customTips": "Benutzerdefiniertes Etikett",
    "addCustomTemplate": "zu \" Persönliche Vorlagen\" hinzufügen",
    "errorFile": "Fehlerdatei",
    "addTemplateSucc": "Vorlage erfolgreich hinzufügen",
    "cancelText": "Abbrechen",
    "useSymbolTip": "Die aktuelle Version unterstützt diese Funktion nicht. Bitte aktualisieren Sie auf V11.5.5 oder neuere Versionen, um sie zu verwenden.",
    "toUpgrade": "Jetzt Aktualisieren",
    "refresh": "Aktualisieren",
    "createFile": "Leere Zeichnung erstellen",
    "import": "Importieren",
    "importFile": "Datei importieren",
    "networkError": "Netzwerkfehler, bitte versuchen Sie es erneut!"
  },
  "jp": {
    "switchView": "ビューを切り替える",
    "addNew": "新規作成",
    "allFiles": "すべてのファイル",
    "personal": "個人クラウド",
    "search": "ファイルを検索",
    "name": "名前",
    "time": "時間",
    "size": "サイズ",
    "customTag": "カスタムラベル",
    "folder": "フォルダ",
    "eddxFile": "ファイル",
    "grid": "グリッドビュー",
    "list": "リストビュー",
    "tag": "ラベル",
    "open": "開く",
    "rename": "名前の変更",
    "download": "ダウンロード",
    "del": "削除",
    "copy": "コピー",
    "cut": "切り取り",
    "moveTo": "移動",
    "copyTo": "コピー",
    "renameFile": "ファイルの名前を変更",
    "renameFolder": "フォルダの名前を変更",
    "confirm": "確認",
    "cancel": "キャンセル",
    "tip": "Edrawからのご注意",
    "share": "共有",
    "shareTip": "ファイルはまだ共有されていません。すぐに共有されますか？",
    "invalidName": "無効な名前",
    "sameName": "名前ファイルはすでに存在します",
    "noEmpty": "名前は空にできません！",
    "delSuccess": "削除しました",
    "fileOverLimit": "ファイルが制限を超えています。最初にいくつかのファイルをクリーンアップしてください",
    "spaceOverLimit": "クラウドスペースが制限を超えています。既存のファイルを先にクリーンアップしてくださ",
    "createCopy": "コピーを作成",
    "createCopySucc": "コピーの作成に成功しました",
    "copySucc": "コピーしました",
    "cutSucc": "カットしました",
    "pasteSucc": "貼り付けました",
    "pasteFail": "貼り付けできませんでした。もう一度お試しください",
    "createFolder": "フォルダの新規作成",
    "inputFileTip": "ファイル名を入力してください",
    "inputFolderTip": "フォルダ名を入力してください",
    "createSucc": "新規ファイルが作成しました",
    "existFolder": "フォルダはすでに存在します",
    "notTem": "クラウドファイルはまだありません",
    "cantDel": "このフォルダには他の形式のファイル（EdrawMindファイル）があり、直接削除できません。",
    "path": "パス",
    "notFind": "関連ドキュメントは見つかりませんでした",
    "moveto": "に移動しました",
    "create": "ファイルを作成しています。しばらくしてからもう一度お試しください",
    "openTips": "ファイルを開いています。しばらくしてからもう一度お試しください",
    "deleteLimit": "無料体験版の場合、ゴミ箱には5つのファイルしか保存できません。",
    "usedStorage": "使用したスペース：",
    "renameFail": "名前の変更に失敗しました、名前に特殊文字を含めることはできません(& % $ \\ \/ \" : * ? < > | . 😊など)",
    "oneSamePreTip": "現在のフォルダには既に　　という名前のファイルが含まれています",
    "oneSameAffTip": "という名前のファイル",
    "mulSamePreTip": "現在のフォルダには",
    "mulSameAffTip": "同じ名前のファイル",
    "replaceFile": "これらのファイルを置き換える",
    "skipFile": "これらのファイルをスキップする",
    "keepAllFile": "すべてのファイルを保持",
    "samePathTitle": "ファイルを置き換えるかスキップする",
    "batch": "一括ダウンロード",
    "etc": "など",
    "newFile": "名前のないファイル",
    "moveSucc": "移動しました",
    "copySuccTo": "ファイルをコピーしました ",
    "moveDirSucc": "移動フォルダ",
    "copyDirSucc": "フォルダをコピーしました ",
    "spaceNotEnough": "個人のクラウドの空間が足りないです。",
    "copyFail": "コピーに失敗しました",
    "moveFail": "移動に失敗しました",
    "move": "移動",
    "fileDownloading": "ダウンロード中…",
    "reloadPre": "インターネットに接続していないようです。",
    "reload": "再読み込み",
    "errFile": "ファイル情報が間違っています。ファイルを修正して再度お試しください。",
    "lockedFile": "ファイルは暗号化されています。共有する前に復号化してください",
    "set": "設定",
    "star": "スター",
    "none": "なし",
    "waitdone": "未完成",
    "done": "完了",
    "waitchange": "修正予定",
    "custom": "カスタマイズ",
    "customTips": "カスタムラベル",
    "addCustomTemplate": "「個人用テンプレート」に追加",
    "errorFile": "ファイルエラー",
    "addTemplateSucc": "テンプレートが正常に追加されました",
    "cancelText": "キャンセル",
    "useSymbolTip": "現在のバージョンでは、この機能はサポートされていません。V 11.5.5以降のバージョンに更新してご使用ください。",
    "toUpgrade": "今すぐアップデート",
    "refresh": "更新",
    "createFile": "空白の図面を作成",
    "import": "インポート",
    "importFile": "ファイルをインポート",
    "networkError": "ネットワークエラー、後でもう一度お試みください！"
  },
  "es": {
    "switchView": "Cambiar vista",
    "addNew": "Añadir",
    "allFiles": "Todos los archivos",
    "personal": "Nube Personal",
    "search": "Buscar archivo",
    "name": "Nombre",
    "time": "Hora",
    "size": "Talla",
    "customTag": "Etiqueta personalizada",
    "folder": "Carpeta",
    "eddxFile": "Archivo",
    "grid": "Vista de cuadrícula",
    "list": "Vista de lista",
    "tag": "Etiqueta",
    "open": "Abrir",
    "rename": "Renombrar",
    "download": "Descargar",
    "del": "Cancelar",
    "copy": "Copiar",
    "cut": "Cortar",
    "moveTo": "Mover a",
    "copyTo": "Copiar a",
    "renameFile": "Cambiar nombre de archivo",
    "renameFolder": "Cambiar nombre de carpeta",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "tip": "Consejos de Edraw",
    "share": "Compartir",
    "shareTip": "Este archivo no se ha compartido, ¿te gustaría compartirlo?",
    "invalidName": "Nombre inválido",
    "sameName": "Ya existe un archivo con el mismo nombre.",
    "noEmpty": "El nombre no puede estar vacío.",
    "delSuccess": "Eliminar con éxito",
    "fileOverLimit": "La cantidad de archivos en la nube de Edraw alcanza el máximo, borre los archivos o borre la papelera de reciclaje.",
    "spaceOverLimit": "El espacio en la nube no es suficiente, elimine los archivos o borre la papelera de reciclaje.",
    "createCopy": "Crea una copia",
    "createCopySucc": "Se creó una copia con éxito",
    "copySucc": "Copia exitosamente",
    "cutSucc": "Cortar con éxito",
    "pasteSucc": "Pegar con éxito",
    "pasteFail": "Error al pegar, por favor intente más tarde.",
    "createFolder": "Crear carpeta",
    "inputFileTip": "Por favor escriba el nombre del archivo",
    "inputFolderTip": "Por favor escriba el nombre de la carpeta",
    "createSucc": "Crear con éxito",
    "existFolder": "Ya existe una carpeta con el mismo nombre.",
    "notTem": "Esta carpeta está vacía",
    "cantDel": "Esta carpeta incluye otros formatos de archivo (por ejemplo, * .emmx), por lo que no puede eliminarla.",
    "path": "Camino",
    "notFind": "No se encontraron archivos relacionados",
    "moveto": "Mover a",
    "create": "Creando archivo, por favor intente nuevamente más tarde.",
    "openTips": "Abriendo el archivo, por favor intente más tarde.",
    "deleteLimit": "La papelera de reciclaje solo puede guardar 5 archivos para no miembro",
    "usedStorage": "Espacio utilizado：",
    "renameFail": "El cambio de nombre falló, verifique si el nombre contiene caracteres especiales, como &% $ 😊, etc.",
    "oneSamePreTip": "Esta carpeta ya incluye",
    "oneSameAffTip": "archivo",
    "mulSamePreTip": "Esta carpeta incluye",
    "mulSameAffTip": "archivos con el mismo nombre",
    "replaceFile": "Reemplazar",
    "skipFile": "Saltar",
    "keepAllFile": "Mantener todo",
    "samePathTitle": "Reemplazar o saltar",
    "batch": "Descarga por lotes",
    "etc": "etc",
    "newFile": "Archivo sin nombre",
    "moveSucc": "Movido con éxito",
    "copySuccTo": "Archivo copiado en ",
    "moveDirSucc": "La carpeta se ha movido",
    "copyDirSucc": "Carpeta copiada a ",
    "spaceNotEnough": "Personal nube Space",
    "copyFail": "Copia fallida",
    "moveFail": "No se puede mover",
    "move": "mover",
    "fileDownloading": "Descargando...",
    "reloadPre": "Parece haber algunos problemas con la red,",
    "reload": "Recargar",
    "errFile": "Error de información del archivo, intenta modificar el archivo y vuelve a intentarlo",
    "lockedFile": "El archivo está cifrado, descifrelo antes de compartirlo",
    "set": "Configura como ",
    "star": "Símbolo de estrella",
    "none": "Nada",
    "waitdone": "Deshecho",
    "done": "Hecho",
    "waitchange": "Es necesario modificar",
    "custom": "Personalizar",
    "customTips": "Etiqueta personalizada",
    "addCustomTemplate": "Agréguelo a \"Plantillas personales\"",
    "errorFile": "Archivo de Error",
    "addTemplateSucc": "Agregar con éxito plantilla",
    "cancelText": "Cancelar",
    "useSymbolTip": "La versión actual no soporta esta función. Por favor, actualiza a la versión V11.5.5 o posterior para poder utilizarla.",
    "toUpgrade": "Actualizar",
    "refresh": "Refrescar",
    "createFile": "Crear un dibujo en blanco",
    "import": "Importar",
    "importFile": "Importar archivo",
    "networkError": "Error de conexión, ¡por favor inténtelo de nuevo!"
  },
  "pt": {
    "switchView": "Trocar Visualização",
    "addNew": "Adicionar",
    "allFiles": "Todos os Ficheiros",
    "personal": "Pessoal",
    "search": "Pesquisar Ficheiro",
    "name": "Nome",
    "time": "Hora",
    "size": "Tamanho",
    "customTag": "Etiquetas personalizadas",
    "folder": "Pasta",
    "eddxFile": "Ficheiro",
    "grid": "Visualização em Grelha",
    "list": "Visualização em Lista",
    "tag": "Identificador",
    "open": "Abrir",
    "rename": "Renomear",
    "download": "Descarregar",
    "del": "Eliminar",
    "copy": "Copiar",
    "cut": "Cortar",
    "moveTo": "Mover para",
    "copyTo": "Copiar para",
    "renameFile": "Renomear Ficheiro",
    "renameFolder": "Renomear Pasta",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "tip": "Dicas Edraw",
    "share": "Partilhar",
    "shareTip": "Este ficheiro não foi partilhado, deseja partilhar？",
    "invalidName": "Nome Inválido",
    "sameName": "Já existe um ficheiro com o mesmo nome.",
    "noEmpty": "Nome não pode estar vazio.",
    "delSuccess": "Eliminado com sucesso",
    "fileOverLimit": "A capacidade de ficheiros da cloud Edraw atingiu o máximo, por favor, eliminar ficheiros ou limpar a sua pasta de reciclagem.",
    "spaceOverLimit": "Espaço da cloud insuficiente, por favor, eliminar ficheiros ou limpar a sua pasta de reciclagem.",
    "createCopy": "Crie uma cópia",
    "createCopySucc": "Cópia criada com sucesso",
    "copySucc": "Copiado com Sucesso",
    "cutSucc": "Cortado com Sucesso",
    "pasteSucc": "Colado com Sucesso",
    "pasteFail": "Falha ao Colar, por favor, tentar mais tarde.",
    "createFolder": "Criar Pasta",
    "inputFileTip": "Por favor, escrever no nome do ficheiro",
    "inputFolderTip": "Por favor, escrever no nome do ficheiro",
    "createSucc": "Criado com Sucesso",
    "existFolder": "Já existe uma pasta com o mesmo nome.",
    "notTem": "Esta pasta está vazia.",
    "cantDel": "Esta pasta inclui outros formatos de ficheiro (ex. *.emmx), por isso não o pode eliminar.",
    "path": "Caminho",
    "notFind": "Não encontrados ficheiros relacionados",
    "moveto": "Mover para",
    "create": "Criando ficheiro, por favor, tentar mais tarde.",
    "openTips": "Abrindo ficheiro, por favor, tentar mais tarde.",
    "deleteLimit": "A pasta de reciclagem só pode manter 5 ficheiros para não membros.",
    "usedStorage": "Espaço Usado:",
    "renameFail": "Falha ao renomear, verificar se o nome contém caracteres especiais, como & % $ \\ \/ \" : * ? < > | . 😊, etc.",
    "oneSamePreTip": "Esta pasta já inclui",
    "oneSameAffTip": "ficheiro",
    "mulSamePreTip": "Esta pasta inclui",
    "mulSameAffTip": "ficheiros com o mesmo nome",
    "replaceFile": "Substituir",
    "skipFile": "Saltar",
    "keepAllFile": "Manter Todos",
    "samePathTitle": "Substituir ou Saltar",
    "batch": "Descarregamento em Lote",
    "etc": "etc",
    "newFile": "Ficheiro Sem Nome",
    "moveSucc": "Movido com Sucesso",
    "copySuccTo": "Arquivo copiado para ",
    "moveDirSucc": "Pasta Movida para",
    "copyDirSucc": "Pasta copiada para ",
    "spaceNotEnough": "Espaço de Nuvem Pessoal insuficiente",
    "copyFail": "Cópia falhou",
    "moveFail": "Falha ao Mover",
    "move": "Mover",
    "fileDownloading": "Baixando...",
    "reloadPre": "Erro de rede",
    "reload": "Clicar para recarregar",
    "errFile": "Erro de informação de arquivos, modifique os arquivos e tente novamente",
    "lockedFile": "O arquivo está criptografado, descriptografe-o antes de compartilhar",
    "set": "definido como",
    "star": "símbolo estrelado",
    "none": "nada",
    "waitdone": "incompleto",
    "done": "Concluído",
    "waitchange": "Precisa ser modificado",
    "custom": "personalizada",
    "customTips": "Etiqueta personalizada",
    "addCustomTemplate": "Adicione-o a \"Modelos Pessoais\"",
    "errorFile": "arquivo de erro",
    "addTemplateSucc": "Adicionar modelo com sucesso",
    "cancelText": "Cancelar",
    "useSymbolTip": "A versão atual não suporta esta função. Por favor, atualize para V11.5.5 ou versões posteriores para usá-lo.",
    "toUpgrade": "Atualize Agora",
    "refresh": "Atualizar",
    "createFile": "Criar desenho em branco",
    "import": "Importar",
    "importFile": "Importar arquivo",
    "networkError": "Erro de rede, por favor, tente novamente!"
  },
  "it": {
    "switchView": "Cambia Vista",
    "addNew": "Aggiungi",
    "allFiles": "Tutti i File",
    "personal": "Personali",
    "search": "Cerca File",
    "name": "Nome",
    "time": "Ora",
    "size": "Dimensione",
    "customTag": "Etichetta personalizzata",
    "folder": "Cartella",
    "eddxFile": "File",
    "grid": "Vista a Griglia",
    "list": "Vista a Elenco",
    "tag": "Tag",
    "open": "Apri",
    "rename": "Rinomina",
    "download": "Scarica",
    "del": "Elimina",
    "copy": "Copia",
    "cut": "Taglia",
    "moveTo": "Sposta In",
    "copyTo": "Copia In",
    "renameFile": "Rinomina File",
    "renameFolder": "Rinomina Cartella",
    "confirm": "Conferma",
    "cancel": "Annulla",
    "tip": "Suggerimenti di Edraw",
    "share": "Condividi",
    "shareTip": "Questo file non è stato condiviso. Desideri condividerlo?",
    "invalidName": "Nome non Valido",
    "sameName": "Esiste già un file con questo nome.",
    "noEmpty": "Il campo del nome non può restare vuoto.",
    "delSuccess": "Eliminazione eseguita con successo.",
    "fileOverLimit": "È stato raggiunto il limite massimo di file archiviabili nel cloud di Edraw. Si prega di eliminare dei file o di svuotare il cestino.",
    "spaceOverLimit": "Spazio nel cloud non sufficiente. Si prega di rimuovere dei file o di svuotare il cestino.",
    "createCopy": "Crea una copia",
    "createCopySucc": "Crea una copia con successo",
    "copySucc": "Copia eseguita con successo.",
    "cutSucc": "Taglio eseguito con successo.",
    "pasteSucc": "Incollamento eseguito con successo.",
    "pasteFail": "Copia fallita. Si prega di riprovare più tardi.",
    "createFolder": "Crea Cartella",
    "inputFileTip": "Immettere un nome per il file.",
    "inputFolderTip": "Immettere un nome per la cartella.",
    "createSucc": "Creazione eseguita con successo.",
    "existFolder": "Esiste già una cartella con questo nome.",
    "notTem": "Questa cartella è vuota.",
    "cantDel": "Questa cartella comprende file di altri formati (per es: *.emmx) e, pertanto, non può essere eliminata.",
    "path": "Percorso",
    "notFind": "Nessun file trovato",
    "moveto": "Sposta In",
    "create": "Creazione file in corso. Si prega di riprovare.",
    "openTips": "Apertura file in corso. Si prega di riprovare.",
    "deleteLimit": "Il cestino può contenere un massimo di 5 file per gli utenti non registrati.",
    "usedStorage": "Spazio Utilizzato: ",
    "renameFail": "Rinominazione fallita. Assicurarsi che il nome del file non comprenda caratteri speciali, quali & % $ \\ \/ \" : * ? < > | . 😊, ecc.",
    "oneSamePreTip": "Questa cartella comprende già",
    "oneSameAffTip": "file",
    "mulSamePreTip": "Questa cartella comprende",
    "mulSameAffTip": "file con lo stesso nome",
    "replaceFile": "Sostituisci ",
    "skipFile": "Salta",
    "keepAllFile": "Mantieni Tutti",
    "samePathTitle": "Sostituisci o Salta",
    "batch": "Scarica in Blocco",
    "etc": "ecc.",
    "newFile": "File Senza Nome",
    "moveSucc": "Spostamento Eseguito con Successo",
    "copySuccTo": "File copiato a ",
    "moveDirSucc": "Cartella spostata a",
    "copyDirSucc": "Cartella copiata a ",
    "spaceNotEnough": "Spazio cloud personale insufficiente",
    "copyFail": "copia non riuscita",
    "moveFail": "Spostamento Fallito",
    "move": "Sposta",
    "fileDownloading": "Scaricamento...",
    "reloadPre": "Sembra che ci siano alcuni problemi con la rete,",
    "reload": "Ricaricare",
    "errFile": "Errore di informazioni sul file, prova a modificare il file e riprova",
    "lockedFile": "Il file è crittografato, decrittalo prima di condividerlo",
    "set": "Impostare",
    "star": "Stella",
    "none": "Niente",
    "waitdone": "Incompiuto",
    "done": "Completato",
    "waitchange": "Bisogna modificare",
    "custom": "Personalizza",
    "customTips": "Etichetta personalizzata",
    "addCustomTemplate": "Aggiungilo a \"Modelli personali\"",
    "errorFile": "file di errore",
    "addTemplateSucc": "Aggiungi il modello con successo",
    "cancelText": "Annulla",
    "useSymbolTip": "La versione attuale non supporta questa funzione. Si prega di aggiornare a V11.5.5 o versioni successive per usarlo.",
    "toUpgrade": "Aggiorna Ora",
    "refresh": "Ricarica",
    "createFile": "Crea un disegno vuoto",
    "import": "Importa",
    "importFile": "Importa file",
    "networkError": "Errore di rete. Si prega di riprovare!"
  },
  "tw": {
    "switchView": "切換視圖",
    "addNew": "新建",
    "allFiles": "所有檔案",
    "personal": "個人雲端硬碟",
    "search": "搜尋檔案",
    "name": "檔案名",
    "time": "時間",
    "size": "大小",
    "customTag": "自定義標籤",
    "folder": "資料夾",
    "eddxFile": "檔案",
    "grid": "網格視圖",
    "list": "列表視圖",
    "tag": "標籤",
    "open": "打開",
    "rename": "重命名",
    "download": "下載",
    "del": "刪除",
    "copy": "複製",
    "cut": "剪下",
    "moveTo": "移動到",
    "copyTo": "複製到",
    "renameFile": "重命名檔案",
    "renameFolder": "重命名資料夾",
    "confirm": "確定",
    "cancel": "取消",
    "tip": "Edraw 提醒",
    "share": "分享",
    "shareTip": "該檔案还未分享，是否立即分享？",
    "invalidName": "名字不能包特殊字符(& % $ \\ \/ \" : * ? < > | . 😊等)",
    "sameName": "該名稱檔案已存在",
    "noEmpty": "名字不能為空！",
    "delSuccess": "刪除成功",
    "fileOverLimit": "檔案超出限制, 請先清理些檔案",
    "spaceOverLimit": "雲端硬碟超出限制，請先清理些檔案",
    "createCopy": "建立副本",
    "createCopySucc": "建立副本成功",
    "copySucc": "複製成功，請按 Ctrl + V 粘貼",
    "cutSucc": "剪下成功",
    "pasteSucc": "貼上成功",
    "pasteFail": "貼上失敗，請重試",
    "createFolder": "新建資料夾",
    "inputFileTip": "請輸入檔案名",
    "inputFolderTip": "請輸入資料夾名",
    "createSucc": "建立成功",
    "existFolder": "資料夾已存在",
    "notTem": "此資料夾為空",
    "cantDel": "該資料夾存在其他格式檔案(MindMaster檔案）， 不能直接操作",
    "path": "路徑",
    "notFind": "沒有找到相關檔案",
    "moveto": "已移動到",
    "create": "正在建立檔案中，請稍後再試",
    "openTips": "正在打開檔案，請稍後再試",
    "deleteLimit": "非會員回收站只能儲存5個檔案",
    "usedStorage": "已用空間：",
    "renameFail": "重命名失敗，名字不能包含特殊字符(& % $ \\ \/ \" : * ? < > | . 😊等)",
    "oneSamePreTip": "当前資料夾已包含一個名為",
    "oneSameAffTip": "的檔案",
    "mulSamePreTip": "当前資料夾包含",
    "mulSameAffTip": "個同名檔案",
    "replaceFile": "替換",
    "skipFile": "跳過",
    "keepAllFile": "保留全部",
    "samePathTitle": "替換或跳過檔案",
    "batch": "批量下載",
    "etc": "等",
    "newFile": "未命名檔案",
    "moveSucc": "檔案已移動到 ",
    "copySuccTo": "檔案已複製到 ",
    "moveDirSucc": "資料夹已移動到 ",
    "copyDirSucc": "資料夹已複製到 ",
    "spaceNotEnough": "個人雲端硬碟不足",
    "copyFail": "複製失敗",
    "moveFail": "移動失敗",
    "move": "移動",
    "fileDownloading": "下載中...",
    "reloadPre": "網絡似乎有些問題，",
    "reload": "重新加載",
    "errFile": "檔案信息錯誤，請嘗試修改檔案後重試",
    "lockedFile": "檔案已加密，請解密後再分享檔案",
    "set": "設為",
    "star": "星標",
    "none": "無",
    "waitdone": "未完成",
    "done": "已完成",
    "waitchange": "需修改",
    "custom": "自定義",
    "customTips": "自定義",
    "cancelText": "取消",
    "useSymbolTip": "當前版本不支持此功能。 請更新至 V11.5.5 或更高版本才能使用。",
    "toUpgrade": "去升級",
    "refresh": "刷新",
    "createFile": "新建空白文件",
    "import": "匯入",
    "importFile": "导入文件",
    "networkError": "網絡錯誤，請重試！"
  },
  "kr": {
    "switchView": "보기 전환",
    "addNew": "새로 만들기",
    "allFiles": "모든 파일",
    "personal": "개인 클라우드",
    "search": "파일 찾기",
    "name": "파일 이름",
    "time": "시간",
    "size": "크기",
    "customTag": "사용자 지정 태그",
    "folder": "폴더",
    "eddxFile": "파일",
    "grid": "그리드보기",
    "list": "목록보기",
    "tag": "태그",
    "open": "열기",
    "rename": "이름 변경",
    "download": "다운로드",
    "del": "삭제",
    "copy": "복사",
    "cut": "자르기",
    "moveTo": "다음 위치로 이동하기",
    "copyTo": "다음 위치로 복사하기",
    "renameFile": "파일 이름 변경",
    "renameFolder": "폴더 이름 변경",
    "confirm": "확인",
    "cancel": "취소",
    "tip": "Edraw 팁",
    "share": "공유",
    "shareTip": "파일이 아직 공유되지 않았습니다. 지금 공유 하시겠습니까?",
    "invalidName": "이름은 특수 문자를 포함 할 수 없습니다.",
    "sameName": "이미 있는 파일 이름입니다",
    "noEmpty": "이름을 비워둘 수 없습니다.",
    "delSuccess": "삭제 성공",
    "fileOverLimit": "파일이 한도를 초과했습니다. 먼저 일부 파일을 정리하세요.",
    "spaceOverLimit": "클라우드 공간이 한도를 초과합니다. 먼저 일부 파일을 정리하세요.",
    "createCopy": "사본 만들기",
    "createCopySucc": "사본 만들기 성공",
    "copySucc": "복사가 완료되었습니다. Ctrl + V를 눌러 붙여 넣으세요.",
    "cutSucc": "자르기 성공",
    "pasteSucc": "붙여넣기 성공",
    "pasteFail": "붙여넣기 실패,다시 시도하세요.",
    "createFolder": "새 폴더 만들기",
    "inputFileTip": "파일 이름 입력",
    "inputFolderTip": "폴더 이름 입력",
    "createSucc": "만들기 성공",
    "existFolder": "이미 있는 폴더입니다",
    "notTem": "빈 폴더입니다",
    "cantDel": "이 폴더에는 다른 형식 파일 (MindMaster 파일)이 있으며 직접 조작 할 수 없습니다.",
    "path": "경로",
    "notFind": "관련 파일이 없습니다.",
    "moveto": "이동",
    "create": "파일을 만드는 중입니다. 나중에 다시 시도하십시오.",
    "openTips": "파일을 여는 중입니다. 나중에 다시 시도하십시오.",
    "deleteLimit": "비회원 휴지통은 10 개의 파일 만 저장할 수 있습니다.",
    "usedStorage": "사용된 공간：",
    "renameFail": "이름 변경 실패,이름에 (& % $ \\ \/ \" : * ? < > | . 😊등)과 같은 특수 문자를 포함할 수 없습니다",
    "oneSamePreTip": "현재 폴더에 이미 같은 이름의",
    "oneSameAffTip": "파일이 있습니다",
    "mulSamePreTip": "현재 폴더에는 이름이 같은 파일이 ",
    "mulSameAffTip": "개 존재합니다.",
    "replaceFile": "바꾸기",
    "skipFile": "건너 뛰기",
    "keepAllFile": "모두 유지하기",
    "samePathTitle": "파일 바꾸기 또는 건너 뛰기",
    "batch": "일괄 다운로드",
    "etc": "등",
    "newFile": "이름 없는 파일",
    "moveSucc": "파일이 이동되었습니다",
    "copySuccTo": "파일이 복사되었습니다",
    "moveDirSucc": "폴더가 이동되었습니다",
    "copyDirSucc": "폴더가 복사되었습니다",
    "spaceNotEnough": "개인 클라우드 공간이 부족합니다.",
    "copyFail": "복사 실패",
    "moveFail": "이동 실패",
    "move": "이동",
    "fileDownloading": "다운로드 중...",
    "reloadPre": "네트워크에 문제가 있습니다.",
    "reload": "다시 로드하기",
    "errFile": "파일 정보 오류입니다. 파일을 수정하고 다시 시도하세요.",
    "lockedFile": "파일이 암호화되어 있습니다. 공유하기 전에 해독하십시오",
    "set": "즐겨",
    "star": "찾기",
    "none": "없음",
    "waitdone": "미완성",
    "done": "완료",
    "waitchange": "수정 필요",
    "custom": "태그 지정",
    "customTips": "맞춤 라벨",
    "addCustomTemplate": "개인 템플릿에 추가",
    "errorFile": "오류 파일",
    "addTemplateSucc": "템플릿 추가 완료",
    "cancelText": "취소",
    "useSymbolTip": "현재 버전은 이 기능을 지원하지 않습니다. V11.5.5 이상 버전으로 업데이트하여 사용하세요.",
    "toUpgrade": "업그레이드하기",
    "refresh": "새로 고침",
    "createFile": "빈 도면 작성하기",
    "import": "가져오기",
    "importFile": "파일 가져오기",
    "networkError": "네트워크 오류입니다. 다시 시도하세요~"
  },
  "id": {
    "switchView": "Ganti Tampilan",
    "addNew": "Baru",
    "allFiles": "Semua File",
    "personal": "Personal",
    "search": "Cari File",
    "name": "Nama",
    "time": "Waktu",
    "size": "Ukuran",
    "customTag": "Tag Kustom",
    "folder": "Folder",
    "eddxFile": "File",
    "grid": "Tampilan Kisi",
    "list": "Tampilan Daftar",
    "tag": "Tag",
    "open": "Buka",
    "rename": "Ganti nama",
    "download": "Unduh",
    "del": "Hapus",
    "copy": "Salin",
    "cut": "Potong",
    "moveTo": "Pindahkan ke",
    "copyTo": "Salin ke",
    "renameFile": "Ganti Nama File",
    "renameFolder": "Ganti Nama Folder",
    "confirm": "Konfirmasi",
    "cancel": "Batalkan",
    "tip": "Tip Edraw",
    "share": "Bagikan",
    "shareTip": "File ini belum dibagikan. Ingin membagikannya？",
    "invalidName": "Nama Tidak Valid",
    "sameName": "File dengan nama yang sama sudah ada.",
    "noEmpty": "Nama tidak boleh kosong.",
    "delSuccess": "Penghapusan berhasil",
    "fileOverLimit": "Jumlah file cloud Edraw mencapai maksimal. Hapus file atau kosongkan tempat sampah Anda.",
    "spaceOverLimit": "Ruang cloud tidak cukup. Hapus file atau kosongkan tempat sampah Anda.",
    "createCopy": "Buat salinan",
    "createCopySucc": "Berhasil membuat salinan",
    "copySucc": "Berhasil menyalin",
    "cutSucc": "Berhasil memotong",
    "pasteSucc": "Berhasil menempel",
    "pasteFail": "Gagal menempel. Coba lagi nanti.",
    "createFolder": "Buat folder",
    "inputFileTip": "Isi nama file",
    "inputFolderTip": "Isi nama folder",
    "createSucc": "Folder berhasil dibuat ",
    "existFolder": "Folder dengan nama yang sama sudah ada.",
    "notTem": "Folder ini kosong.",
    "cantDel": "Folder ini berisi format file lainnya (mis. *.emmx) sehingga Anda tidak dapat menggunakannya.",
    "path": "Path",
    "notFind": "File terkait tidak ditemukan",
    "moveto": "Dipindahkan ke ",
    "create": "Membuat file. Coba lagi nanti.",
    "openTips": "Membuka file. Coba lagi nanti.",
    "deleteLimit": "Tempat sampah hanya dapat menyimpan 5 file untuk nonanggota.",
    "usedStorage": "Ruang yang Digunakan: ",
    "renameFail": "Gagal mengganti nama. Pastikan nama tidak berisi karakter khusus, seperti & % $ \\ \/ \" : * ? < > | . 😊, dll.",
    "oneSamePreTip": "Folder ini sudah berisi ",
    "oneSameAffTip": "file",
    "mulSamePreTip": "Folder ini berisi",
    "mulSameAffTip": "file dengan nama yang sama",
    "replaceFile": "Ganti ",
    "skipFile": "Lewati",
    "keepAllFile": "Simpan Semua",
    "samePathTitle": "Ganti atau Lewati",
    "batch": "Unduh Massal",
    "etc": "dll.",
    "newFile": "File Tanpa Nama",
    "moveSucc": "File berhasil dipindahkan ke ",
    "copySuccTo": "File berhasil disalin ke ",
    "moveDirSucc": "Folder berhasil dipindahkan ke ",
    "copyDirSucc": "Folder disalin ke ",
    "copyFail": "Gagal Menyalin",
    "spaceNotEnough": "Ruang cloud pribadi tidak mencukupi",
    "moveFail": "Gagal Memindahkan",
    "move": "Pindahkan",
    "fileDownloading": "Mengunduh ....",
    "reloadPre": "Kesalahan jaringan",
    "reload": "klik untuk memuat ulang",
    "errFile": "kesalahan info file, ubah file dan coba lagi",
    "lockedFile": "File dienkripsi. Dekripsikan file sebelum dibagikan",
    "set": "Tambahkan ",
    "star": "bintang",
    "none": "Tidak",
    "waitdone": "Sedang Diproses",
    "done": "Selesai",
    "waitchange": "Perlu dimodifikasi",
    "custom": "Kustomisasi",
    "customTips": "Label kustom",
    "addCustomTemplate": "Tambahkan ke \"Templat Pribadi\"",
    "errorFile": "errorfile",
    "addTemplateSucc": "Berhasil menambahkan templat",
    "cancelText": "Batalkan",
    "useSymbolTip": "Versi terbaru tidak mendukung fungsi ini. Perbarui ke V11.5.5 atau versi yang lebih baru untuk menggunakannya.",
    "toUpgrade": "Perbarui Sekarang",
    "refresh": "Muat Ulang",
    "createFile": "Buat gambar kosong",
    "import": "Impor",
    "importFile": "Impor file",
    "networkError": "Terjadi kesalahan jaringan. Coba lagi!"
  }
}
</i18n>
